"use client"
import React, { Component } from 'react';
import { withRouter } from "react-router-dom";

import { useState, useEffect } from "react"
import Select from "react-select"
import Datetime from "react-datetime" // Import Datetime component
import "react-datetime/css/react-datetime.css"
import redirectURL from '../redirectURL';
import SweetAlert from "react-bootstrap-sweetalert"
import RFQView from './rfqpreviewcomponent.js';
import Modal from 'react-responsive-modal';
import Toast from './toastcomponent.js';
import $ from "jquery" // Assuming jQuery is available
import { emitDataReceived } from "../socketManager.js";
var moment = require("moment")

// --- Data Options (from CreateRFQComponent) ---
const bidvalidityoptions = Array.from({ length: 18 }, (_, i) => {
  const hours = (i + 1) * 2; // generates 2, 4, 6 ... 36
  return { value: String(hours), label: `${hours} Hours` };
});


const typeoftrucksoption = [
  { value: "6 Wheeler", label: "6 Wheeler" },
  { value: "8 Wheeler", label: "8 Wheeler" },
  { value: "10 Wheeler", label: "10 Wheeler" },
  { value: "12 Wheeler", label: "12 Wheeler" },
  { value: "14 Wheeler", label: "14 Wheeler" },
  { value: "Container 20ft", label: "Container 20ft" },
  { value: "Container 40ft", label: "Container 40ft" },
  { value: "Refrigerated Truck", label: "Refrigerated Truck" },
  { value: "Open Truck", label: "Open Truck" },
  { value: "Tanker", label: "Tanker" },
  { value: "Flatbed Truck", label: "Flatbed Truck" },
  { value: "Lowboy Truck", label: "Lowboy Truck" },
  { value: "Mini Truck", label: "Mini Truck" },
  { value: "Tipper Truck", label: "Tipper Truck" },
  { value: "Trailer Truck", label: "Trailer Truck" },
  { value: "Box Truck", label: "Box Truck" },
]

const formatDateTime = (date) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, "0")
  const day = String(date.getDate()).padStart(2, "0")
  const hours = String(date.getHours()).padStart(2, "0")
  const minutes = String(date.getMinutes()).padStart(2, "0")
  return `${year}-${month}-${day} ${hours}:${minutes}`
}

var typeofselection = [{ label: "Spot", value: "Spot" }]
var incotermsoption = [
  { label: "EXW", value: "EXW" },
  { label: "FOB", value: "FOB" },
  { label: "FCA", value: "FCA" },
  { label: "FAS", value: "FAS" },
  { label: "CIF", value: "CIF" },
  { label: "CNF", value: "CNF" },
  { label: "CPT", value: "CPT" },
  { label: "CIP", value: "CIP" },
]
var pick_drop_option = [
  { label: "PORT(ORIGIN) TO PORT(DESTINATION)", value: "port_to_port" },
  { label: "PORT(ORIGIN) TO DOOR(DESTINATION)", value: "pprt_to_door" },
  { label: "DOOR(ORIGIN) TO PORT(DESTINATION)", value: "door_to_port" },
  { label: "DOOR(ORIGIN) TO DOOR(DESTINATION)", value: "door_to_door" },
]
var origin_port_list = [
  { label: "Mundra", value: "mundra" },
  { label: "Pipara", value: "pipara" },
  { label: "ICS Sanand", value: "icd_sanand" },
  { label: "ICD Garhi", value: "icd_garhi" },
  { label: "Chennai", value: "chennai" },
  { label: "Kattupalli", value: "kattupalli" },
]
var destination_port_list = [
  { label: "Mundra", value: "mundra" },
  { label: "Pipara", value: "pipara" },
  { label: "ICS Sanand", value: "icd_sanand" },
  { label: "ICD Garhi", value: "icd_garhi" },
  { label: "Chennai", value: "chennai" },
  { label: "Kattupalli", value: "kattupalli" },
]
var stuffing_location_list = [
  { label: "Dock/CFS", value: "dock_cfs" },
  { label: "Factory", value: "factory" },
]
var destuffing_location_list = [
  { label: "Dock/CFS", value: "dock_cfs" },
  { label: "Factory", value: "factory" },
  { label: "DPD", value: "dpd" },
]
var hsn_code_list = [
  { label: "84", value: "84" },
  { label: "85", value: "85" },
  { label: "27", value: "27" },
  { label: "72", value: "72" },
  { label: "87", value: "87" },
  { label: "39", value: "39" },
  { label: "90", value: "90" },
  { label: "28-38", value: "28-38" },
  { label: "50-63", value: "50-63" },
  { label: "44", value: "44" },
]
var payment_terms_list = [{ label: "As per agreed terms", value: "As per agreed terms" }]
const now = new Date()
const NEW_VENDOR_OPTIONS = [
  { label: "WinEx Logistics", value: "WinEx Logistics" },
  { label: "Jai Mata Logistics", value: "Jai Mata Logistics" },
  { label: "NEGL", value: "NEGL" },
  { label: "VRL Logistics", value: "VRL Logistics" },
  { label: "BGFC Logistics", value: "BGFC Logistics" },
  { label: "Inland Logistics", value: "Inland Logistics" },
  { label: "DRK logistics", value: "DRK logistics" },
  { label: "Mass Logistics", value: "Mass Logistics" },
  { label: "Madhur", value: "Madhur" },
  { label: "Avyansh Logistic", value: "Avyansh Logistic" },
  { label: "Shreejain Roadways", value: "Shreejain Roadways" },
  { label: "Adroit Logistics", value: "Adroit Logistics" },
  { label: "Instant Logistics", value: "Instant Logistics" },
]

const getNewDealerCodesOptions = (dealer_code_options, dealers) => {
  const temp_dealer_codes = []
  let selected_d_codes = []
  if (dealers.length > 0) {
    selected_d_codes = dealers.map((ele) => ele.dealer_code)
  }
  for (const ele of dealer_code_options) {
    if (selected_d_codes.includes(ele.label)) {
      temp_dealer_codes.push({
        value: ele.value,
        label: ele.label,
        isDisabled: true,
        consignee_code: ele.consignee_code,
      })
    } else {
      temp_dealer_codes.push({ value: ele.value, label: ele.label, consignee_code: ele.consignee_code })
    }
  }
  return temp_dealer_codes
}



// --- CreateRFQComponent Functional Component ---
const CreateRFQComponent = (props) => {
  const { rfq_id } = props.match.params
  const [rfqForm, setRfqForm] = useState({
    auction_type: "Spot",
    bid_start_date: moment().format('YYYY-MM-DD HH:mm'),
    additional_comments: "",
    quotation_validity_hours: 8,
    dealer_pincode: "",
    dealer_city: "",
    timeChanged: false,
    payment_terms: "As per agreed terms", // Default value from list
    bidding_window: "",
    negotiation_window: '',
    base_price: "",
    without_insurance: false,
    bidVisibility: false,
    pickup_date: moment().toDate(), // Initialize with Date object
  })
  const [materialdimensionlist, setmaterialdimensionlist] = useState([])
  const [toast, setToast] = useState({ message: "", type: "success" }); // type: 'success' | 'error'
  const [vendorslist, setvendorslist] = useState([])
  const [isEditing, setIsEditing] = useState(false);
  const [vendorsemail, setvendorsemail] = useState([])
  const [group_names, setgroup_names] = useState([])
  const [errorforvehicletime, seterrorforvehicletime] = useState(false)
  const [rfqFormforsea, setRfqFormforsea] = useState({
    auction_type: "spot",
    bid_start_date: moment().format("YYYY-MM-DD HH:mm:ss"),
    additional_comments: "",
    quotation_validity_hours: 8,
    payment_terms1: "",
    destuffing_location: "",
    origin_address: "",
    origin_port: "",
    additional_details: "",
    stuffing_location: "",
    destination_port: "",
    destination_address: "",
    cargo_invoice_value: "",
    hs_code: "",
    product: "",
    pickup_date: "",
    bid_close_date: "",
    upload_file_sea: "",
  })
  const [loadshow, setLoadshow] = useState("show-n")
  const [overlay, setoverlay] = useState('show-n')
  const [activeTab, setActiveTab] = useState("totalShipment")
  const [weight_20ft_Unit, setweight_20ft_Unit] = useState("KG")
  const [base_price_sea, set_base_price_sea] = useState("")
  const [volume_20ft_Unit, setvolume_20ft_Unit] = useState("CBM")
  const [weight_20ft, setweight_20ft] = useState("")
  const [volume_20ft, setvolume_20ft] = useState("")
  const [show, setShow] = useState(false)
  const [sweetAlert, setSweetAlert] = useState({ show: false, basicTitle: "", basicType: "" })
  const [containerInfo, setcontainerInfo] = useState({
    movementType: "import",
    shipmentType: "road",
    cargoMode: "fcl",
  })
  const [containers, setContainers] = useState([{ weight: "", unit: "20ft" }])
  const [basicType, setBasicType] = useState("")
  const [formshow, setformshow] = useState("road")
  const [basicTitle, setBasicTitle] = useState("")
  const [vendorOptions, setVendorOptions] = useState(NEW_VENDOR_OPTIONS)
  const [dealersdata, setdealersdata] = useState([])
  const [citiesoption, setcitiesoption] = useState([])
  const [dealer_pincode_list, setdealer_pincode_list] = useState([])
  const [dealer_city_list, setdealer_city_list] = useState([])
  const [drag_file, setdrag_file] = useState("")
  const [source_list, setsource_list] = useState([])
  const [truck_type, settruck_type] = useState([])
  const [units_list, setUnits_list] = useState([])
  const [dealers, setDealers] = useState([])
  const [isAddDealerModalOpen, setIsAddDealerModalOpen] = useState(false)
  const [currentDealerIndex, setCurrentDealerIndex] = useState(null)
  const [currentMaterialIndex, setCurrentMaterialIndex] = useState(null)
  const initialDealerData = {
    dealer_code: "",
    dealer_name: "",
    dealer_city: "",
    dealer_state: "",
    dealer_pincode: "",
    materials: [],
  };
  const [newDealerData, setNewDealerData] = useState({
    dealer_code: "",
    dealer_name: "",
    dealer_city: "",
    dealer_state: "",
    dealer_pincode: "",
    materials: [

    ],
  })

  const [oldDealerCodeForEdit, setOldDealerCodeForEdit] = useState("")

  useEffect(() => {
    redirectURL.post('/consignments/getsourcemaster').then((resp) => {
      let data = resp.data;
      let source_list = [];

      data.forEach((e) => {
        if (e.source_name != '' && e.source_name != undefined) {
          source_list.push({ value: e.source_name, label: e.source_name });
        }
      });

      setsource_list(source_list);
    })

    redirectURL.post('/consignments/getrfqtrucktype').then((resp) => {
      let data = resp.data;
      let truck_type_list = [];
      data.forEach((e) => {
        truck_type_list.push({ value: e.truck_type, label: e.truck_type });
      });
      truck_type_list.push({ value: "others", label: "Others" })
      settruck_type(truck_type_list);
    })

    redirectURL.post('/consignments/getRfqUnits').then((resp) => {
      let data = resp.data;
      let units_list = [];
      data.forEach((e) => {
        units_list.push({ value: e.unit, label: e.unit });
      });
      units_list.push({ value: "others", label: "Others" })
      setUnits_list(units_list);
    })
    redirectURL.post('/consignments/getsetmaterialdimensionlist').then((resp) => {
      let data = resp.data;
      let list_material = [];

      data.forEach((e) => {
        list_material.push({ value: e.value, label: e.label });
      });

      setmaterialdimensionlist(list_material);
    });

  }, [])
  useEffect(() => {
    fetchTransporterUsers();
  }, []);

  const [originCharges, setOriginCharges] = useState({
    cfsWarehouse: true,
    port: true,
    customsClearance: true,
  })
  const [destinationCharges, setDestinationCharges] = useState({
    cfsWarehouse1: true,
    port1: true,
    customsClearance1: true,
  })
  const [vendormasterdata, setvendormasterdata] = useState([])
  const [isPreviewMode, setIsPreviewMode] = useState(false)
  const [packageCount, setPackageCount] = useState(0)
  const [packageCount_unit, set_packagecount_unit] = useState("")
  const [length, setLength] = useState("")
  const [breadth, setBreadth] = useState("")
  const [height, setHeight] = useState("")
  const [grossWeight, setGrossWeight] = useState("")
  const [volume, setVolume] = useState(0)
  const [gross_wt_units, setgross_wt_units] = useState("KG")
  const [packages, setPackages] = useState([
    {
      packageCount: "",
      packageCount_unit: "Carton",
      length: "",
      breadth: "",
      height: "",
      dimensionUnit: "ft",
      grossWeight: "",
      gross_wt_units: "KG",
    },
  ])
  const [vendormaster, setVendormaster] = useState([])
  const [material_list, setmaterial_list] = useState([])

  useEffect(() => {
    redirectURL.post("/consignments/getmateriallist").then((resp) => {
      var material_list_data = resp.data
      var materialSet = new Set()
      material_list_data.forEach((e) => {
        if (e.material_type && e.material_type.trim() !== "") {
          materialSet.add(e.material_type.trim())
        }
      })
      var material_list = Array.from(materialSet).map((item) => ({
        label: item,
        value: item,
      }))
      material_list.push({ label: "Others", value: "others" })
      setmaterial_list(material_list)
    })

    redirectURL.post("/consignments/fetchvendorlist").then((resp) => {
      var vendors = resp.data
      var vendorslist = []
      vendors.map((e) => {
        if (e.email != "" && e.email != undefined) {
          vendorslist.push({ label: e.firstname, value: e.email })
        }
      })
      setVendormaster(vendorslist)
    })

    redirectURL.post("/consignments/fetchdealerslist").then((resp) => {
      var dealers = resp.data
      var dealerslist = []
      var dealercitylist = []
      var dealerpincodelist = []
      setdealersdata(dealers)
      dealers.map((e) => {
        if (e.consignee_code != "Demo" && e.consignee_city != "" && e.consignee_city != undefined) {
          dealerslist.push({
            label: e.internal_code,
            value: `${e.consignee_name} - ${e.internal_code}`,
            consignee_name: e.consignee_name,
            consignee_code: e.consignee_code,
          })
          dealercitylist.push({ label: e.consignee_city, value: e.consignee_city })
          dealerpincodelist.push({ label: e.consignee_pincode, value: e.consignee_pincode })
        }
      })
      setcitiesoption(dealerslist)
      setdealer_city_list(dealercitylist)
      setdealer_pincode_list(dealerpincodelist)
    })

    const fetchData = async () => {
      try {
        const resp = await redirectURL.post("consignments/fetchVendors")
        const vendorsData = resp.data
        let vendorOptions = []
        const categoryOptions = []
        vendorsData.forEach((e) => {
          vendorOptions.push({ label: e.vendor_name, value: [e.email_id] })
          const categoryOption = categoryOptions.find((f) => f.label === e.category)
          if (!categoryOption) {
            categoryOptions.push({ label: e.category, value: [e.email_id] })
          } else {
            categoryOption.value.push(e.email_id)
          }
        })
        vendorOptions = vendorOptions.concat(categoryOptions)

        if (rfq_id) {
          try {
            const response = await redirectURL.post("consignments/fetchRFQs", { _id: rfq_id })
            const record = response.data[0]
            var destination_list = JSON.parse(record.destination || "[]")
            var vendorsData1 = JSON.parse(record.vendors_names || "[]")
            var vendor_list = record.vendors && record.vendors.length > 0 ? record.vendors : []
            var vendor_names = vendor_list
            var selected_vendor_names = []
            if (vendor_names != "" && vendor_names != undefined) {
              vendor_names.map((e) => {
                if (!selected_vendor_names.includes(e.value)) {
                  selected_vendor_names.push(e.value)
                }
              })
            }
            setgroup_names(selected_vendor_names)

            const vendorEmails = record.vendors || []
            const matchedVendors = vendorEmails
              .map((email) => vendorOptions.find((option) => option.value.length === 1 && option.value[0] === email))
              .filter(Boolean)

            var selected_source = record.source || ""

            const vendors_mail = record.vendors_mail && record.vendors_mail.length > 0 ? record.vendors_mail : []
            setvendorsemail(vendors_mail)
            const timeToMinutes = (timeStr) => {
              if (!timeStr) return 0;

              // if it's already a number, return it
              if (typeof timeStr === "number") return timeStr;

              // if it's a Date object, extract hours/minutes
              if (timeStr instanceof Date) {
                return timeStr.getHours() * 60 + timeStr.getMinutes();
              }

              // if it's string "HH:mm"
              if (typeof timeStr === "string" && timeStr.includes(":")) {
                const [hours, minutes] = timeStr.split(":").map(Number);
                return (hours || 0) * 60 + (minutes || 0);
              }

              // fallback: try parsing to integer
              return parseInt(timeStr, 10) || 0;
            };

            // document.getElementById("fileInput").value =record.upload_for_road
            setRfqForm((prevState) => ({
              ...prevState,
              ...record,
              bid_start_date: moment().format('YYYY-MM-DD HH:mm'),
              pickup_date: moment(record.pickup_date).toDate(), // Convert to Date object
              vendors: vendor_list,
              destination: destination_list,
              bidVisibility: record.show_bids || false,
              source: record.source || "",
              vendors_mail: vendors_mail,
              over_length: record.over_length,
              over_breath: record.over_breath,
              upload_for_road: record.upload_for_road,
              bidding_window: (record.bidding_window), // ✅ convert HH:mm → minutes
              negotiation_window: (record.negotiation_window) // ✅ convert HH:mm → minutes
              //   rfqForm.over_length
            }))
            setvendorslist(vendor_list)
            setDealers(
              destination_list.map((destination) => ({
                dealer_code: destination.dealer_code || "",
                dealer_name: destination.dealer_name || "",
                dealer_state: destination.dealer_state || "",
                dealer_city: destination.dealer_city || "",
                dealer_pincode: destination.dealer_pincode || "",
                materials: destination.materials.map((material) => ({
                  material_type: material.material_type || "",
                  other_material_type: material.other_material_type || "",
                  material_length: material.material_length || 0,
                  material_breath: material.material_breath || 0,
                  material_height: material.material_height || 0,
                  material_units: material.material_units || "ft",
                  quantity: material.quantity || 0,
                  basic_requirment: material.basic_requirment || "",
                })),
              })),
            )
          } catch (error) {
          }
        }
      } catch (error) {
      }
    }
    fetchData()
  }, [rfq_id])

  const calculateVolume = (l, b, h) => {
    if (l && b && h) {
      return (l * b * h) / 1000000
    }
    return 0
  }
  const fetchTransporterUsers = () => {
    redirectURL.post("/consignments/fetchVendors", {}, {
    })
      .then((res) => {
        const respData = res.data;
        if (respData != '' && respData != undefined) {

          setvendormasterdata(respData)
        }
      })
      .catch((err) => {
      });
  };

  const updateVolume = () => {
    const vol = calculateVolume(length, breadth, height)
    setVolume(vol.toFixed(2))
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setRfqForm({ ...rfqForm, [name]: value })
  }

  const handleInputChange1 = (e) => {
    const { name, value } = e.target
    setRfqFormforsea({ ...rfqFormforsea, [name]: value })
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    if (!file) return
    const fileName = file.name
    const fileExtension = fileName.split(".").pop().toLowerCase()
    const validExtensions = ["pdf", "png", "jpeg"]
    if (validExtensions.includes(fileExtension)) {
      setdrag_file(e.target.files[0])
    } else {
      alert("Invalid file type. Only PDF, PNG, and JPEG files are allowed.")
      $("#payment_terms").val("")
    }
  }
  const editMaterial = (dealer) => {
    setNewDealerData(dealer);     // populate form with this dealer's data
    setOldDealerCodeForEdit(dealer.dealer_code)
    setIsEditing(true);           // indicate we're editing
    setIsAddDealerModalOpen(true)
    setoverlay('show-m')

  }


  const removeMaterial = (dealerIndex, materialIndex) => {
    const updatedDealers = [...dealers];

    // If only 1 material left, remove the entire dealer
    if (updatedDealers[dealerIndex].materials.length === 1) {
      updatedDealers.splice(dealerIndex, 1); // remove the dealer
    } else {
      // Otherwise remove only the selected material
      updatedDealers[dealerIndex].materials.splice(materialIndex, 1);
    }

    setDealers(updatedDealers);
  };

  const onClickHideall = () => {
    setLoadshow('show-n')
    setoverlay('show-n')
    setIsAddDealerModalOpen(false)
  };
  const handleMaterialChange = (dealerIndex, materialIndex, key, value) => {
    const numericFields = ["quantity", "material_breath", "material_length", "material_height"]
    if (numericFields.includes(key)) {
      value = value.replace(/[^0-9.]/g, "")
      const parts = value.split(".")
      if (parts.length > 2) {
        value = parts[0] + "." + parts.slice(1).join("")
      }
    }
    setDealers((prevDealers) => {
      const updatedDealers = [...prevDealers]
      const updatedMaterials = [...updatedDealers[dealerIndex].materials]
      updatedMaterials[materialIndex] = {
        ...updatedMaterials[materialIndex],
        [key]: value,
      }
      updatedDealers[dealerIndex] = {
        ...updatedDealers[dealerIndex],
        materials: updatedMaterials,
      }
      return updatedDealers
    })
  }

  const removeContainer = (index) => {
    const updatedContainers = containers.filter((_, i) => i !== index)
    setContainers(updatedContainers)
  }

  const onchangeFileHandler = (e) => {
    if (!e.target || !e.target.files || e.target.files.length === 0) {
      return
    }
    const file = e.target.files[0]
    const fileName = file.name
    const fileExtension = fileName.split(".").pop().toLowerCase()
    const validExtensions = ["pdf", "png", "jpeg", "jpg"]
    if (validExtensions.includes(fileExtension)) {
      setRfqForm({ ...rfqForm, upload_for_road: fileName })
      setRfqForm((prev) => ({
        ...prev,
        uploadFile: file,
      }))
    } else {
      alert("Invalid file type. Only PDF, PNG, and JPEG files are allowed.")
      document.getElementById("fileInput").value = ""
    }
  }

  const onchangeFileHandler1 = (e) => {
    const file = e.target.files[0]
    if (!file) return
    const fileName = file.name
    const fileExtension = fileName.split(".").pop().toLowerCase()
    const validExtensions = ["pdf", "png", "jpeg"]
    if (validExtensions.includes(fileExtension)) {
      setRfqFormforsea((prev) => {
        return { ...prev, upload_file_sea: e.target.files[0] }
      })
    } else {
      alert("Invalid file type. Only PDF, PNG, and JPEG files are allowed.")
      $("#payment_terms").val("")
    }
  }

  function handleCheckboxChange(field, value) {
    setRfqForm((prevState) => ({
      ...prevState,
      [field]: value,
    }))
  }

  const handleOriginChange = (e) => {
    const { name, checked } = e.target
    setOriginCharges((prev) => ({
      ...prev,
      [name]: checked,
    }))
  }

  const handlePreview = () => {
    setIsPreviewMode(true)
  }

  const handleDestinationChange = (e) => {
    const { name, checked } = e.target
    setDestinationCharges((prev) => ({
      ...prev,
      [name]: checked,
    }))
  }

  const onClickButtonHandler1 = (cargoMode, e) => {
    setcontainerInfo({ ...containerInfo, [cargoMode]: e })
  }

  const onClickButtonHandler2 = (movementType, e) => {
    setcontainerInfo({ ...containerInfo, [movementType]: e })
  }

  const onClickButtonHandler = (shipment_type, e) => {
    if (e == "road") {
      setformshow("road")
      setcontainerInfo({ ...containerInfo, [shipment_type]: e })
    } else if (e == "sea") {
      setformshow("sea")
      setcontainerInfo({ ...containerInfo, [shipment_type]: e })
    } else if (e == "air") {
      setformshow("air")
      setcontainerInfo({ ...containerInfo, [shipment_type]: e })
    }
  }

  const onClickcreaterfqforsea = (e) => {
    e.preventDefault()
    var saveData = new FormData()
    if (rfqFormforsea.upload_file_sea) {
      saveData.append("upload_file_sea", rfqForm.upload_file_sea)
    }
    var selected_containers = []
    var no_of_containers = 0
    containers.map((e) => {
      if (e != "" && e != undefined) {
        if (e.weight != "" && e.weight != undefined) {
          const weight = Number.parseInt(e.weight, 10) || 0
          selected_containers.push({ container_type: e.unit, container_qty: weight })
          no_of_containers += weight
        }
      }
    })
    let no_of_participants = 0
    const selectedvendors = []
    rfqFormforsea.vendors.forEach((e) => {
      e.value.forEach((f) => {
        if (!selectedvendors.includes(f)) {
          selectedvendors.push(f)
          no_of_participants += 1
        }
      })
    })
    var movement
    if (containerInfo.movementType == "import") {
      movement = "IMPORT"
    } else if (containerInfo.movementType == "export") {
      movement = "EXPORT"
    }
    if (rfqFormforsea.additional_details != "" && rfqFormforsea.additional_details != undefined) {
      saveData.append("additional_comments_check", "1")
    }
    saveData.append("movement_type", movement)
    saveData.append("no_of_participants", no_of_participants)
    saveData.append("vendors", JSON.stringify(selectedvendors))
    saveData.append("cargo_type", rfqFormforsea.cargo_type)
    saveData.append("weight_20ft", weight_20ft)
    saveData.append("weight_20ft_Unit", weight_20ft_Unit)
    saveData.append("no_of_containers", no_of_containers)
    saveData.append("quantity", no_of_containers)
    saveData.append("volume_20ft", volume_20ft)
    saveData.append("volume_20ft_Unit", volume_20ft_Unit)
    saveData.append("containers", JSON.stringify(selected_containers))
    saveData.append("incoterm", rfqFormforsea.incoterm)
    saveData.append("pick_and_drop", rfqFormforsea.pick_and_drop)
    saveData.append("destuffing_location", rfqFormforsea.destuffing_location)
    saveData.append("source", rfqFormforsea.origin_address)
    saveData.append("origin_port", rfqFormforsea.origin_port)
    saveData.append("stuffing_location", rfqFormforsea.stuffing_location)
    saveData.append("destination_port", rfqFormforsea.destination_port)
    saveData.append("destination", rfqFormforsea.destination_address)
    saveData.append("cargo_invoice_value", rfqFormforsea.cargo_invoice_value)
    saveData.append("hs_code", rfqFormforsea.hs_code)
    saveData.append("product", rfqFormforsea.product)
    saveData.append("material", rfqFormforsea.material)
    saveData.append("customsClearance_origin", originCharges.customsClearance)
    saveData.append("cfsWarehouse_origin", originCharges.cfsWarehouse)
    saveData.append("port_origin", originCharges.port)
    saveData.append("customsClearance_destination", destinationCharges.customsClearance1)
    saveData.append("cfsWarehouse_destination", destinationCharges.cfsWarehouse1)
    saveData.append("port_destination", destinationCharges.port1)
    saveData.append("additional_details", rfqFormforsea.additional_details)
    saveData.append("bid_close_date", rfqFormforsea.bid_close_date)
    saveData.append("pickup_date", rfqFormforsea.pickup_date)
    saveData.append("base_price", base_price_sea)
    saveData.append("packageCount_unit", packageCount_unit)
    saveData.append("packageCount", packageCount)
    saveData.append("length", length)
    saveData.append("breadth", breadth)
    saveData.append("height", height)
    saveData.append("gross_wt_units", gross_wt_units)
    saveData.append("grossWeight", grossWeight)
    saveData.append("created_by", localStorage.getItem("email"))
    saveData.append("quotation_validity_hours", rfqFormforsea.quotation_validity_hours)
    setLoadshow("show-n")
    redirectURL.post("consignments/saverfqindentforsea", saveData).then((response) => {
      setShow(true)
      setBasicType(response.data.status == "success" ? "success" : "danger")
      setBasicTitle(response.data.message)
      setLoadshow("show-n")
    })
  }


  const onClickcreaterfq = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault()
    }
    if (formshow == "road") {
      if (dealers.length > 0) {
        let dealersfilter = dealers.filter(function (dealer) {
          return dealer.dealer_code && dealer.dealer_code.trim() !== "";
        });
        setDealers(dealersfilter)
      }
      // var params = { plant_name: rfqForm.selected_source_type }
      // redirectURL.post("/consignments/insertsource", params).then((resp) => { })
      // let materialType = ""
      // for (let i = 0; i < dealers.length; i++) {
      //   if (dealers[i].materials && dealers[i].materials.length > 0) {
      //     materialType = dealers[i].materials[0].other_material_type || ""
      //     if (materialType) break
      //   }
      // }
      // var materialParams = { material_type: materialType }
      // if (materialType != "" && materialType != undefined) {
      //   redirectURL.post("/consignments/insertmaterial", materialParams).then((resp) => { })
      // }
      const formData = new FormData()
      let no_of_participants = 0
      const selectedvendors = []
      const selectedVendorsName = []
      const vendors_names = []
      const vendorsToProcess =
        rfqForm.vendors_mail && rfqForm.vendors_mail.length > 0 ? rfqForm.vendors_mail : vendorsemail
      vendorsToProcess.map((e) => {
        if (!selectedvendors.includes(e.value)) {
          selectedvendors.push(e.value)
          selectedVendorsName.push(e.label)
          no_of_participants += 1
        }
      })
      var dealers_arr = dealers
      const validate_dates = {
        bid_start_date: "Please provide valid Bid Start Date",
        pickup_date: "Please provide valid Pickup Date",
      }
      for (const v in validate_dates) {
        if (!(rfqForm[v] && moment(rfqForm[v]).isValid())) {
          setSweetAlert({ show: true, basicTitle: validate_dates[v] || "", basicType: "danger" })
          return
        }
      }
      const validate_rfq_form = {
        auction_type: "Please provide valid Auction type",
        source: "Please provide valid Source",
        units: "Please provide valid Units",
        type_of_truck: "Please provide valid Truck type",
        quotation_validity_hours: "Please provide Indent Validity",
      }
      const validate_others = {
        source: "selected_source_type",
        units: "selected_units",
        type_of_truck: "selected_truck_type",
        material_type: "other_material_type",
      }
      for (const v in validate_rfq_form) {
        let bool = false
        if (!rfqForm[v] || (validate_others[v] && rfqForm[v] === "others" && !rfqForm[validate_others[v]])) {
          bool = true
        }
        if (bool) {
          setSweetAlert({ show: true, basicTitle: validate_rfq_form[v] || "", basicType: "danger" })
          return
        }
      }
      if (!rfqForm.vendors_mail || rfqForm.vendors_mail.length == 0) {
        setSweetAlert({ show: true, basicTitle: "Please select vendors", basicType: "danger" })
        return
      }
      if (!rfqForm.bidding_window) {
        setSweetAlert({ show: true, basicTitle: "Please Enter Bidding Cutoff", basicType: "danger" })
        return
      }
      if (!rfqForm.negotiation_window) {
        setSweetAlert({ show: true, basicTitle: "Please Enter Negotiation Cutoff", basicType: "danger" })
        return
      }
      if (errorforvehicletime) {
        setSweetAlert({ show: true, basicTitle: "Please select vehicle placement date&time", basicType: "danger" })
        return
      }
      const validate_dealers = {
        dealer_code: "Please select Dealer Code",
        dealer_name: "Please provide valid Dealer Name",
        dealer_city: "Please provide valid Dealer City",
        dealer_state: "Please provide valid Dealer State",
        dealer_pincode: "Please provide valid Dealer Pincode",
      }
      const validate_materials = {
        material_type: "Please provide valid Material Type",
        material_length: "Please provide valid Material Dimensions",
        material_breath: "Please provide valid Material Dimensions",
        material_height: "Please provide valid Material Dimensions",
        material_units: "Please provide valid Material Dimensional Units",
        quantity: "Please provide valid Material Quantity",
        // basic_requirment: "Please provide valid Material Basic Prerequisite",
      }
      var dealerslist = dealers.filter(function (dealer) {
        return dealer.dealer_code && dealer.dealer_code.trim() !== "";
      });
      if (dealerslist && dealerslist.length > 0) {
        for (const ele of dealerslist) {
          for (const v in validate_dealers) {
            if (!ele[v]) {
              setSweetAlert({ show: true, basicTitle: validate_dealers[v] || "", basicType: "danger" })
              return
            }
          }
          if (!ele.materials || !ele.materials.length > 0) {
            setSweetAlert({ show: true, basicTitle: "Please provide Material Details.", basicType: "danger" })
            return
          }
          for (const mat of ele.materials) {
            for (const v in validate_materials) {
              let bool = false
              if (["material_length", "material_breath", "material_height"].includes(v)) {
                if (!(mat[v] >= 0)) bool = true
              } else if (!mat[v] || (validate_others[v] && mat[v] === "others" && !mat[validate_others[v]])) {
                bool = true
              }
              if (bool) {
                setSweetAlert({ show: true, basicTitle: validate_materials[v] || "", basicType: "danger" })
                return
              }
            }
          }
        }
      } else {
        setSweetAlert({ show: true, basicTitle: "Please provide Dealers Details.", basicType: "danger" })
        return
      }
      let otherMaterialValues = []; // <-- store all "other" material values here

      let dealers_list = dealers.map(dealer => {
        const cleanedMaterials = (dealer.materials || []).map(mat => {

          // BEFORE modifying, collect the "others" value
          if (mat.material_type === "others" && mat.other_material_type) {
            otherMaterialValues.push(mat.other_material_type);
          }

          // Replace "others" with actual value
          if (mat.material_type === "others" && mat.other_material_type) {
            return {
              ...mat,
              material_type: mat.other_material_type
            };
          }

          return mat;
        })
          .map(mat => {
            // Remove the key after storing
            const copy = { ...mat };
            delete copy.other_material_type;
            return copy;
          });

        return {
          ...dealer,
          materials: cleanedMaterials
        };
      });

      var saveData = new FormData()
      if (rfqForm.payment_terms) {
        saveData.append("payment_terms", rfqForm.payment_terms)
      }
      saveData.append("source", rfqForm.source || "")
      saveData.append("selected_source_type", rfqForm.selected_source_type || "")
      saveData.append("type_of_truck", rfqForm.type_of_truck || "")
      saveData.append("selected_truck_type", rfqForm.selected_truck_type || "")
      saveData.append("bidding_window", rfqForm.bidding_window)
      saveData.append("negotiation_window", rfqForm.negotiation_window)
      saveData.append("podDoc", rfqForm.uploadFile)
      saveData.append("auction_type", rfqForm.auction_type)
      saveData.append("material", rfqForm.material)
      saveData.append("quantity", rfqForm.quantity)
      saveData.append("bid_start_date", rfqForm.bid_start_date)
      saveData.append("quotation_validity_hours", rfqForm.quotation_validity_hours)
      saveData.append("pickup_date", rfqForm.pickup_date)
      saveData.append("vendors", JSON.stringify(selectedvendors))
      saveData.append("vendors_names", JSON.stringify(selectedVendorsName))
      saveData.append("destination", JSON.stringify(dealers_list))
      saveData.append("other_material_types", JSON.stringify(otherMaterialValues))
      saveData.append("additional_comments", rfqForm.additional_comments)
      saveData.append("no_of_participants", no_of_participants)
      saveData.append("total_km", rfqForm.total_km)
      saveData.append("dealers_arr", dealers_arr)
      if (rfqForm.without_insurance == true) {
        saveData.append("without_insurance", 1)
      }
      if (rfqForm.bidVisibility == true) {
        saveData.append("show_bids", 1)
      }
      if (rfqForm.base_price != "" && rfqForm.base_price != undefined) {
        saveData.append("base_price", rfqForm.base_price)
      } else {
        saveData.append("base_price", "0")
      }
      saveData.append("units", rfqForm.units || "")
      saveData.append("selected_units", rfqForm.selected_units || "")
      if (rfqForm.over_breath == true) {
        saveData.append("over_breath", 1)
      }
      if (rfqForm.show_bids == true) {
        saveData.append("show_bids", 1)
      }
      if (rfqForm.over_length == true) {
        saveData.append("over_length", 1)
      }
      if (rfq_id) {
        saveData.append("rfq_id", rfq_id)
      }
      if (rfqForm.indent_id) {
        saveData.append("indent_id", rfqForm.indent_id)
      }
      saveData.append("email", localStorage.getItem("email"))
      setLoadshow("show-m")
      redirectURL
        .post("/billing/addOrEditRFQ", saveData)
        .then((response) => {
          const message = response.data.message
          const parts = message.split("Indent ")[1].split(" created successfully")
          const indentId = parts[0]
          setShow(true)
          setBasicType(response.data.status === "success" ? "success" : "danger")
          setBasicTitle(
            <span>
              Indent <b>{indentId}</b> created successfully
            </span>,
          )
          setLoadshow("show-n")
          emitDataReceived({ action: "Create RFQ" })
        })
        .catch((error) => {
          console.error("Error:", error.response || error.message)
        })
    }
  }

  const onSelectItems = (items) => {
    try {
      var vendor_names = items
      var selected_vendor_names = []
      if (vendor_names != "" && vendor_names != undefined) {
        vendor_names.map((e) => {
          if (!selected_vendor_names.includes(e.value)) {
            selected_vendor_names.push(e.value)
          }
        })
      }
      setgroup_names(selected_vendor_names)
      setRfqForm((prev) => {
        return { ...prev, vendors: items }
      })
      setvendorslist(items)
      var params = { vendors: selected_vendor_names }
      redirectURL
        .post("/consignments/getvendorsemails", params)
        .then((resp) => {
          var data = resp.data
          var vendors_mail = []
          if (Array.isArray(data)) {
            data.map((e) => {
              vendors_mail.push({ label: e.firstname, value: e.email })
            })
          } else {
          }
          setRfqForm((prev) => {
            return { ...prev, vendors_mail: vendors_mail }
          })
        })
    } catch (e) { }
  }

  const onSelectItemsfordealers = (items) => {
    try {
      if (items.length <= 10) {
        setRfqForm({ ...rfqForm, destination: items })
      } else {
        alert("You can select up to 10 options only.")
      }
    } catch (e) {
    }
  }

  const onSelectItems3 = (selectedOptions) => {
    rfqForm.destination = selectedOptions.map((option) => ({
      value: Array.isArray(option.value) ? option.value : [option.value],
      label: option.label,
    }))
  }

  const onSelectItems1 = (items) => {
    try {
      setRfqFormforsea({ ...rfqFormforsea, vendors: items })
    } catch (e) { }
  }

  const handleSelectChange = (name, selectedOption) => {
    setRfqForm({ ...rfqForm, [name]: selectedOption.value })
  }
  const handleSelectChangeforsource = (name, selectedOption) => {
    setRfqForm({ ...rfqForm, [name]: selectedOption.value });

    if (name === "source") {
      const dealer_codes = [];
      dealers.forEach((ele) => {
        if (ele.consignee_code) {
          dealer_codes.push(ele.consignee_code);
        }
      });
      handleDistanceCalc(selectedOption.value, dealer_codes);
    }

    // Find all vendors where selected source matches any value in source_name array
    const matchingSources = vendormasterdata.filter(
      item => Array.isArray(item.source_name) && item.source_name.includes(selectedOption.value)
    );

   

    // Map into options for dropdown
    const vendorOptions = matchingSources.map(src => ({
      label: src.source || src.firstname,
      value: src.email,
      // ...src
    }));

    console.log(vendorOptions , "vendorOptions")

    // setVendorOptions(vendorOptions);
    setvendorslist(vendorOptions); 
    setRfqForm((prev) => {
            return { ...prev, vendors_mail: vendorOptions }
          })
    // onSelectItems(vendorOptions);
  };


  const handleInputChangefordealer = (index, field, value) => {
    const updatedDealers = [...dealers]
    updatedDealers[index] = {
      ...updatedDealers[index],
      [field]: value,
    }
    setDealers(updatedDealers)
  }

  const select_dealer_code = (index, selectedOption) => {
    const updatedDealers = [...dealers]
    const selected_dealer = dealersdata.find((e) => e.internal_code == selectedOption.label)
    if (selected_dealer) {
      updatedDealers[index] = {
        ...updatedDealers[index],
        dealer_code: selectedOption.label,
        consignee_code: selectedOption.consignee_code || "",
        dealer_city: selected_dealer.consignee_city,
        dealer_state: selected_dealer.consignee_state,
        dealer_name: selected_dealer.consignee_name,
        dealer_pincode: selected_dealer.consignee_pincode,
      }
    } else {
      updatedDealers[index] = {
        ...updatedDealers[index],
        dealer_code: selectedOption.label,
        consignee_code: selectedOption.consignee_code || "",
        dealer_city: "",
        dealer_pincode: "",
      }
    }
    setDealers(updatedDealers)
    const dealer_codes = []
    updatedDealers.forEach((ele) => {
      if (ele.consignee_code) {
        dealer_codes.push(ele.consignee_code)
      }
    })
    handleDistanceCalc(rfqForm.source, dealer_codes)
  }

  const handleSelectChangeforsea = (name, selectedOption) => {
    setRfqFormforsea({ ...rfqFormforsea, [name]: selectedOption.value })
  }

  const handlerStartDateTime = (name, event) => {
    setRfqForm({ ...rfqForm, bid_start_date: event.toDate() }) // Use toDate() for consistency
  }

  const handlercloseDateTime = (name, event) => {
    var d = new Date(event._d)
    var startdate =
      d.getFullYear() +
      "-" +
      (d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1) +
      "-" +
      (d.getDate() < 10 ? "0" + d.getDate() : d.getDate())
    var starttime =
      (d.getHours() < 10 ? "0" + d.getHours() : d.getHours()) +
      ":" +
      (d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes())
    var formattedStartDateTime = startdate + " " + starttime
    setRfqFormforsea({ ...rfqFormforsea, bid_close_date: d })
  }

  const handlerpickupDateTimeforsea = (name, event) => {
    var d = new Date(event._d)
    var startdate =
      d.getFullYear() +
      "-" +
      (d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1) +
      "-" +
      (d.getDate() < 10 ? "0" + d.getDate() : d.getDate())
    var starttime =
      (d.getHours() < 10 ? "0" + d.getHours() : d.getHours()) +
      ":" +
      (d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes())
    var formattedStartDateTime = startdate + " " + starttime
    setRfqFormforsea({ ...rfqFormforsea, pickup_date: d })
  }

  const handlerPickupDateTime = (name, event) => {
    setRfqForm({ ...rfqForm, pickup_date: event.toDate() }) // Use toDate() for consistency
  }

  const handlervehicleDateTime = (name, date) => {
    if (date && date.isValid()) {
      const now = moment()
      const selectedDate = moment(date)
      if (selectedDate.isSame(now, "day") && !rfqForm.timeChanged) {
        selectedDate.hour(now.hour())
        selectedDate.minute(now.minute())
      }
      setRfqForm((prev) => ({
        ...prev,
        [name]: selectedDate.toDate(),
        timeChanged: true,
      }))
      if (selectedDate && moment(selectedDate).format("HH:mm") === "00:00") {
        seterrorforvehicletime(true)
      } else {
        seterrorforvehicletime(false)
      }
    } else {
      setRfqForm((prev) => ({
        ...prev,
        [name]: null,
        timeChanged: false,
      }))
    }
  }

  const handlerPickupDateTime1 = (name, event) => {
    var d = new Date(event._d)
    setRfqFormforsea({ ...rfqFormforsea, pickup_date: d })
  }

  const handlerStartDateTime1 = (name, event) => {
    var d = new Date(event._d)
    setRfqFormforsea({ ...rfqFormforsea, bid_start_date: d })
  }

  const headStyle = {
    marginBottom: "1.5%",
  }

  const onSaveDraft = () => {
    const params = {}
    Object.keys(rfqForm).forEach((key) => {
      const value = rfqForm[key]
      if (value !== undefined && value !== null) {
        params[key] = value
      }
    })
    if (dealers && dealers.length > 0) {
      let otherMaterialValues = []; // <-- store all "other" material values here

      let dealers_list = dealers.map(dealer => {
        const cleanedMaterials = (dealer.materials || []).map(mat => {

          // BEFORE modifying, collect the "others" value
          if (mat.material_type === "others" && mat.other_material_type) {
            otherMaterialValues.push(mat.other_material_type);
          }

          // Replace "others" with actual value
          if (mat.material_type === "others" && mat.other_material_type) {
            return {
              ...mat,
              material_type: mat.other_material_type
            };
          }

          return mat;
        })
          .map(mat => {
            // Remove the key after storing
            const copy = { ...mat };
            delete copy.other_material_type;
            return copy;
          });

        return {
          ...dealer,
          materials: cleanedMaterials
        };
      });
      params.dealers = dealers_list
      params.other_material_types = otherMaterialValues
      //   params.dealers = dealers
    }
    if (rfqForm.over_breath == true) {
      params.over_breath = true
    }
    else {
      params.over_breath = false
    }
    if (rfqForm.over_length == true) {
      params.over_length = true
    }
    else {
      params.over_length = false
    }
    if (rfqForm.upload_for_road != '') {
      params.upload_for_road = rfqForm.upload_for_road
    }
    params.draft = true
    params.email = localStorage.getItem("email") || "unknown"
    delete params.uploadFile
    delete params.upload_for_road
    redirectURL
      .post("/billing/saveDraft", params)
      .then((response) => {
        setShow(true)
        setBasicType("success")
        setBasicTitle("Draft saved successfully!")
      })
      .catch((error) => {
        console.error("Error saving draft:", error.response || error.message)
        setShow(true)
        setBasicType("danger")
        setBasicTitle("Failed to save draft. Please try again.")
      })
  }

  const [dragFile, setDragFile] = useState(null)

  const addNewPackage = () => {
    setPackages([
      ...packages,
      {
        packageCount: "",
        packageCount_unit: "Carton",
        length: "",
        breadth: "",
        height: "",
        dimensionUnit: "ft",
        grossWeight: "",
        gross_wt_units: "KG",
      },
    ])
  }

  const handlePackageChange = (index, field, value) => {
    const updatedPackages = [...packages]
    updatedPackages[index][field] = value
    setPackages(updatedPackages)
  }

  const handleDivClick = () => {
    document.getElementById("fileInput").click()
  }

  var Disabledfordestination = false
  var Disabledfordestinationimport = false
  if (containerInfo.movementType == "export") {
    Disabledfordestination = true
  } else if (containerInfo.movementType == "import") {
    Disabledfordestinationimport = true
  } else {
    Disabledfordestination = false
  }

  const handleDistanceCalc = (source, destinations) => {
    const payload = {}
    if (!(source && destinations && destinations.length > 0)) {
      return
    }
    payload.source = source
    payload.destinations = destinations
    redirectURL
      .post("/billing/getdistanceCalculation", payload)
      .then((response) => {
        if (response.data && response.data.records && response.data.records.status === "Success") {
          const temp = Number.parseFloat(response.data.records.final_distance)
          const temp1 = isNaN(temp) ? 0 : Number.parseFloat(temp.toFixed(2))
          setRfqForm((prev) => ({ ...prev, total_km: temp1 }))
        }
      })
      .catch((error) => {
      })
  }

  const openAddDealerModal = () => {
    setNewDealerData({
      dealer_code: "",
      dealer_name: "",
      dealer_city: "",
      dealer_state: "",
      dealer_pincode: "",
      materials: [
        {
          material_type: "",
          other_material_type: "",
          material_length: 0,
          material_breath: 0,
          material_height: 0,
          material_units: "ft",
          quantity: 0,
          basic_requirment: "",
        },
      ],
    })
    setIsAddDealerModalOpen(true)
    setoverlay('show-m')
    // setLoadshow('show-m')
  }
  //   const removeMaterialFromModal = (indexToRemove) => {
  //     setNewDealerData((prev) => {
  //       const updatedMaterials = prev.materials.filter((_, index) => index !== indexToRemove);
  //       return {
  //         ...prev,
  //         materials: updatedMaterials.length > 0
  //           ? updatedMaterials
  //           : [
  //               {
  //                 material_type: "",
  //                 other_material_type: "",
  //                 material_length: "",
  //                 material_breath: "",
  //                 material_height: "",
  //                 material_units: "",
  //                 quantity: "",
  //                 basic_requirment: "",
  //               },
  //             ], // Keep at least one row if all are removed
  //       };
  //     });
  //   };

  const closeAddDealerModal = () => {
    setIsAddDealerModalOpen(false)
    setoverlay('show-n')
  }

  const handleNewDealerChange = (field, value) => {
    setNewDealerData((prev) => ({ ...prev, [field]: value }))
  }
  const isMaterialFilled = (material) => {
    return (
      material.material_type &&
      material.material_length &&
      material.material_breath &&
      material.material_height &&
      material.material_units &&
      material.quantity
    );
  };

  const handleNewMaterialChange = (materialIndex, key, value) => {
    setNewDealerData((prev) => {
      const updatedMaterials = [...prev.materials];
      updatedMaterials[materialIndex] = {
        ...updatedMaterials[materialIndex],
        [key]: value === '' ? 0 : value, // 👈 Convert empty string to 0
      };
      return { ...prev, materials: updatedMaterials };
    });
  };

  const addNewMaterialToModal = () => {
    setNewDealerData((prev) => ({
      ...prev,
      materials: [
        ...prev.materials,
        {
          material_type: "",
          other_material_type: "",
          material_length: 0,
          material_breath: 0,
          material_height: 0,
          material_units: "ft",
          quantity: 0,
          basic_requirment: "",
        },
      ],
    }))
  }

  const removeMaterialFromModal = (materialIndex) => {
    setNewDealerData((prev) => {
      const updatedMaterials = [...prev.materials]
      updatedMaterials.splice(materialIndex, 1)
      return { ...prev, materials: updatedMaterials }
    })
  }
  // const saveandaddNewDealer = () => {
  //   // Validate dealer_code
  //   if (!newDealerData.dealer_code || newDealerData.dealer_code.trim() === '') {
  //     setToast({ message: "Please select a Dealer Code.", type: "error", title: 'Error' });
  //     return;
  //   }

  //   // Validate materials array exists and has at least one entry
  //   if (!Array.isArray(newDealerData.materials) || newDealerData.materials.length === 0) {
  //     setToast({ message: "Please add at least one material.", type: "error", title: 'Error' });
  //     return;
  //   }

  //   // Validate each material fields
  //   const isMaterialFilled = (material) =>
  //     material.material_type && material.material_type.trim() !== '' &&
  //     material.material_length !== '' &&
  //     material.material_breath !== '' &&
  //     material.material_height !== '' &&
  //     material.material_units && material.material_units.trim() !== '' &&
  //     material.quantity !== '';

  //   const allMaterialsValid = newDealerData.materials.every(isMaterialFilled);

  //   if (!allMaterialsValid) {
  //     setToast({ message: "Please fill all fields in material section before saving.", type: "error", title: 'Error' });
  //     return;
  //   }

  //   // Save dealer
  //   const updatedDealers = [...dealers, newDealerData];
  //   setDealers(updatedDealers);

  //   // Extract valid consignee codes
  //   const dealer_codes = updatedDealers
  //     .filter((ele) => ele.consignee_code)
  //     .map((ele) => ele.consignee_code);

  //   handleDistanceCalc(rfqForm.source, dealer_codes);

  //   // Reset form for next entry
  //   setNewDealerData({
  //     dealer_code: "",
  //     dealer_name: "",
  //     dealer_city: "",
  //     dealer_state: "",
  //     dealer_pincode: "",
  //     materials: [
  //       {
  //         material_type: null,
  //         other_material_type: "",
  //         material_length: 0,
  //         material_breath: 0,
  //         material_height: 0,
  //         material_units: "cm",
  //         quantity: 0,
  //         basic_requirment: "",
  //       },
  //     ],
  //   });

  //   setToast({ message: "Dealer & Material Details Saved. You can add another now.", type: "success", title: 'Success' });

  //   // Optionally reopen modal if needed
  //   // openAddDealerModal();
  // };


  // const saveandaddNewDealer = () => {
  //     // Validate dealer_code
  //     if (!newDealerData.dealer_code) {
  //       alert("Please select a Dealer Code.");
  //       return;
  //     }

  //     // Validate materials
  //     const isMaterialFilled = (material) =>
  //       material.material_type &&
  //       material.material_length &&
  //       material.material_breath &&
  //       material.material_height &&
  //       material.material_units &&
  //       material.quantity 

  //     const allMaterialsValid = Array.isArray(newDealerData.materials) &&
  //       newDealerData.materials.every(isMaterialFilled);

  //     if (!allMaterialsValid) {
  //       alert("Please fill all fields in material section before saving.");
  //       return;
  //     }

  //     // Save dealer
  //     const updatedDealers = [...dealers, newDealerData];
  //     setDealers(updatedDealers);

  //     // Extract valid consignee codes
  //     const dealer_codes = updatedDealers
  //       .filter((ele) => ele.consignee_code)
  //       .map((ele) => ele.consignee_code);

  //     handleDistanceCalc(rfqForm.source, dealer_codes);

  //     // Reset form
  //     setNewDealerData({
  //         dealer_code: "",
  //         dealer_name: "",
  //         dealer_city: "",
  //         dealer_state: "",
  //         dealer_pincode: "",
  //         materials: [
  //           {
  //             material_type: null, 
  //             other_material_type: "",
  //             material_length: 0,
  //             material_breath: 0,
  //             material_height: 0,
  //             material_units: "cm",
  //             quantity: 0,
  //             basic_requirment: "",
  //           },
  //         ],
  //       })
  //     //   openAddDealerModal()

  //   };
  //   const saveNewDealer = () => {
  //     const { dealer_code, dealer_name, dealer_city, dealer_state, dealer_pincode, materials } = newDealerData;



  //     const isMaterialValid = materials.every((mat) =>
  //       mat.material_type &&
  //       mat.material_length &&
  //       mat.material_breath &&
  //       mat.material_height &&
  //       mat.material_units &&
  //       mat.quantity
  //     );

  //     if (!isMaterialValid) {
  //       setToast({ message: "Please fill all material details.", type: "error",title:'Error' });
  //       return;
  //     }

  //     let updatedDealers;

  //     if (isEditing) {
  //       updatedDealers = dealers.map((dealer) =>
  //         dealer.dealer_code === newDealerData.dealer_code ? newDealerData : dealer
  //       );
  //     } else {
  //       updatedDealers = [...dealers, newDealerData];
  //     }

  //     setDealers(updatedDealers);

  //     const dealer_codes = updatedDealers
  //       .filter((ele) => ele.consignee_code)
  //       .map((ele) => ele.consignee_code);

  //     handleDistanceCalc(rfqForm.source, dealer_codes);

  //     setNewDealerData({
  //       dealer_code: "",
  //       dealer_name: "",
  //       dealer_city: "",
  //       dealer_state: "",
  //       dealer_pincode: "",
  //       materials: [
  //         {
  //           material_type: "",
  //           other_material_type: "",
  //           material_length: '',
  //           material_breath: '',
  //           material_height: '',
  //           material_units: "",
  //           quantity: '',
  //           basic_requirment: "",
  //         },
  //       ],
  //     });

  //     setIsEditing(false);
  //     closeAddDealerModal();
  //   if (
  //   dealer_code === '' ||
  //   dealer_name === '' ||
  //   dealer_city === '' ||
  //   dealer_state === '' ||
  //   dealer_pincode === '' ||
  //   dealer_code === undefined ||
  //   dealer_name === undefined ||
  //   dealer_city === undefined ||
  //   dealer_state === undefined ||
  //   dealer_pincode === undefined
  // ) {
  //   setToast({ message: "Please fill all dealer details.", type: "error", title: 'Error' });
  //   return;
  // }

  //     setToast({ message: "Dealer & Material Details Saved.", type: "success",title:'success' });
  //   };
  const saveandaddNewDealer = () => {
    // Validate dealer_code
    if (!newDealerData.dealer_code || newDealerData.dealer_code.trim() === '') {
      setToast({ message: "Please select a Dealer Code.", type: "error", title: 'Error' });
      return;
    }

    // Validate materials array exists and has at least one entry
    if (!Array.isArray(newDealerData.materials) || newDealerData.materials.length === 0) {
      setToast({ message: "Please add at least one material.", type: "error", title: 'Error' });
      return;
    }

    // Validate each material fields
    const isMaterialFilled = (material) =>
      material.material_type && material.material_type.trim() !== '' &&
      material.material_length !== '' && parseFloat(material.material_length) > 0 &&
      material.material_breath !== '' && parseFloat(material.material_breath) > 0 &&
      material.material_height !== '' && parseFloat(material.material_height) > 0 &&
      material.material_units && material.material_units.trim() !== '' &&
      material.quantity !== '' && parseInt(material.quantity) > 0;

    const allMaterialsValid = newDealerData.materials.every(isMaterialFilled);

    if (!allMaterialsValid) {
      setToast({ message: "Please ensure all material fields are filled with valid (non-zero) values.", type: "error", title: 'Error' });
      return;
    }

    // Save dealer
    const updatedDealers = [...dealers, newDealerData];
    setDealers(updatedDealers);

    // Extract valid consignee codes
    const dealer_codes = updatedDealers
      .filter((ele) => ele.consignee_code)
      .map((ele) => ele.consignee_code);

    handleDistanceCalc(rfqForm.source, dealer_codes);

    // Reset form for next entry
    setNewDealerData({
      dealer_code: "",
      dealer_name: "",
      dealer_city: "",
      dealer_state: "",
      dealer_pincode: "",
      materials: [
        {
          material_type: null,
          other_material_type: "",
          material_length: '',
          material_breath: '',
          material_height: '',
          material_units: "ft",
          quantity: '',
          basic_requirment: "",
        },
      ],
    });

    setToast({ message: "Dealer & Material Details Saved. You can add another now.", type: "success", title: 'Success' });

    // Optionally reopen modal if needed
    // openAddDealerModal();
  };

  const saveNewDealer = () => {
    const { dealer_code, dealer_name, dealer_city, dealer_state, dealer_pincode, materials } = newDealerData;

    // Validate Dealer Details
    if (
      !dealer_code || dealer_code.trim() === '' ||
      !dealer_name || dealer_name.trim() === '' ||
      !dealer_city || dealer_city.trim() === '' ||
      !dealer_state || dealer_state.trim() === '' ||
      !dealer_pincode || dealer_pincode.trim() === ''
    ) {
      setToast({ message: "Please fill all dealer details.", type: "error", title: 'Error' });
      return;
    }

    // Validate Material Details Exist
    if (!materials || materials.length === 0) {
      setToast({ message: "Please add at least one material.", type: "error", title: 'Error' });
      return;
    }

    // Validate Each Material
    const isMaterialValid = materials.every((mat) =>
      mat.material_type && mat.material_type.trim() !== '' &&
      mat.material_units && mat.material_units.trim() !== '' &&
      // mat.material_length !== '' &&
      // mat.material_breath !== '' &&
      // mat.material_height !== '' &&
      mat.quantity !== '' && parseInt(mat.quantity) > 0
    );

    if (!isMaterialValid) {
      setToast({ message: "Please fill all material details with non-zero valid values.", type: "error", title: 'Error' });
      return;
    }
    // Save Dealer & Materials
    let updatedDealers;
    if (isEditing) {
      const filterData = dealers.filter(e => e.dealer_code != oldDealerCodeForEdit)
      updatedDealers = [...filterData, newDealerData]
    } else {
      updatedDealers = [...dealers, newDealerData];
    }

    setDealers(updatedDealers);

    const dealer_codes = updatedDealers
      .filter((ele) => ele.consignee_code)
      .map((ele) => ele.consignee_code);

    handleDistanceCalc(rfqForm.source, dealer_codes);

    // Reset Form
    setNewDealerData({
      dealer_code: "",
      dealer_name: "",
      dealer_city: "",
      dealer_state: "",
      dealer_pincode: "",
      materials: [
        {
          material_type: "",
          other_material_type: "",
          material_length: '',
          material_breath: '',
          material_height: '',
          material_units: "",
          quantity: '',
          basic_requirment: "",
        },
      ],
    });

    setIsEditing(false);
    closeAddDealerModal();

    setToast({ message: "Dealer & Material Details Saved.", type: "success", title: 'Success' });
  };


  const select_new_dealer_code = (selectedOption) => {
    const selected_dealer = dealersdata.find((e) => e.internal_code === selectedOption.label)
    if (selected_dealer) {
      setNewDealerData((prev) => ({
        ...prev,
        dealer_code: selectedOption.label,
        consignee_code: selectedOption.consignee_code || "",
        dealer_city: selected_dealer.consignee_city,
        dealer_state: selected_dealer.consignee_state,
        dealer_name: selected_dealer.consignee_name,
        dealer_pincode: selected_dealer.consignee_pincode,
      }))
    } else {
      setNewDealerData((prev) => ({
        ...prev,
        dealer_code: selectedOption.label,
        consignee_code: selectedOption.consignee_code || "",
        dealer_city: "",
        dealer_pincode: "",
      }))
    }
  }
  const isDealerListEmpty =
    dealers.length === 0 ||
    dealers.every(
      (dealer) =>
        !dealer.dealer_code &&
        !dealer.dealer_name &&
        !dealer.dealer_city &&
        !dealer.dealer_state &&
        !dealer.dealer_pincode &&
        (!dealer.materials || dealer.materials.length === 0 ||
          dealer.materials.every((mat) =>
            !mat.material_type &&
            !mat.basic_requirment &&
            !mat.quantity &&
            !mat.material_height &&
            !mat.material_breath &&
            !mat.material_length
          )
        )
    );
  const cellStyle = {
    border: "1px solid #e0e0e0",
    padding: "12px",
    verticalAlign: "top",
  };

  const isDealerRowFilled = (dealer) => {
    const { dealer_code, dealer_name, dealer_city, dealer_state, dealer_pincode, materials } = dealer;

    const hasBasicInfo = dealer_code || dealer_name || dealer_city || dealer_state || dealer_pincode;

    const hasMaterialInfo =
      Array.isArray(materials) &&
      materials.some(
        (mat) =>
          mat.material_type ||
          mat.basic_requirment ||
          mat.quantity ||
          mat.material_breath ||
          mat.material_length ||
          mat.material_height
      );

    return hasBasicInfo || hasMaterialInfo;
  };
  const styles =
    window.location.pathname === "/createindent"
      ? {} // no styles
      : { padding: "25px", marginLeft: "20px" };
  return (
    <div>
      <SweetAlert
        show={sweetAlert.show}
        type={sweetAlert.basicType}
        title={sweetAlert.basicTitle}
        confirmBtnCssClass={`btn btn-${sweetAlert.basicType}`}
        onConfirm={() => {
          setSweetAlert({ show: false, basicTitle: "", basicType: "" })
        }}
      ></SweetAlert>
      <SweetAlert
        show={show}
        type={basicType}
        title={basicTitle}
        confirmBtnCssClass={`btn btn-${basicType}`}
        onConfirm={() => {
          setShow(false)
          window.location.href = "/indentsummary"
        }}
      ></SweetAlert>
      <>
        <div style={styles}>
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="fbold f18 mb-10p">
              <a href="/" style={{ textDecoration: "none", color: "#333" }}>
                <i className="icofont icofont-home"></i>
              </a>
              <span> / Create Indent</span>
            </h5>

            {/* Back Arrow + Back Text as a Link */}
            <a
              href="/indentsummary"
              className="back-btn d-flex align-items-center"
              style={{ textDecoration: 'none', color: '#101010', fontSize: '14px', marginRight: '35px' }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M15 8a.5.5 0 0 1-.5.5H3.707l3.147 3.146a.5.5 0 0 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L3.707 7.5H14.5A.5.5 0 0 1 15 8z" />
              </svg>
              <span style={{ marginLeft: '5px' }}>Back</span>
            </a>
          </div>
          <div className={"row col-xl-12 col-lg-12"}>

            <>
              <form className="aircargo-form" encType="multipart/form-data" onSubmit={onClickcreaterfq}>
                <div
                // className="card"
                // style={{ border: "1px solid #e0e0e0", borderRadius: "8px", marginBottom: "20px" }}
                >
                  <div>
                    {formshow == "road" ? (
                      <>
                        <div
                          className="card"
                          style={{
                            border: "1px solid #e0e0e0",
                            borderRadius: "8px",
                            marginBottom: "20px",
                            padding: '6px'
                          }}
                        >
                          <h5 style={{ fontSize: "18px", fontWeight: "600", marginLeft: "12px", marginTop: '10px' }}>
                            Basic Information
                          </h5>
                          <div className="row col-xl-12" style={{ paddingRight: '0px' }}>
                            <div className="col-xl-2 mt-20p">
                              <label>
                                RFQ Type<span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                id="auction_type"
                                name="auction_type"
                                value={rfqForm.auction_type}
                                className="form-control"
                                style={{
                                  borderRadius: '4px',
                                  height: '36px', // Height of the input
                                  // paddingRight: '90px', // Leave space for the button inside the input
                                  backgroundColor: '#f7f7f7', // Optional background color
                                }}
                                autoComplete="off"
                                onChange={handleInputChange}
                                readOnly
                              />
                              {/* <Select
                                value={typeofselection.filter((e) => e.value == rfqForm.auction_type)}
                                closeMenuOnSelect={true}
                                onChange={(selectedOption) => handleSelectChange("auction_type", selectedOption)}
                                options={typeofselection}
                                styles={{ control: (provided) => ({ ...provided, minHeight: "45px" }) }}
                                required
                              /> */}
                            </div>
                            <div className="col-xl-2 mt-20p">
                              <label>
                                Source<span style={{ color: "red" }}>*</span>
                              </label>
                              <Select
                                value={source_list.filter((e) => e.value == rfqForm.source)}
                                closeMenuOnSelect={true}
                                onChange={(selectedOption) => handleSelectChangeforsource("source", selectedOption)}
                                options={source_list}
                                styles={{ control: (provided) => ({ ...provided, minHeight: "36px" }) }}
                                required
                              />
                            </div>
                            {rfqForm.source == "others" && (
                              <div className="col-xl-2 mt-20p">
                                <label>Enter Source</label>
                                <input
                                  type="text"
                                  name="selected_source_type"
                                  value={rfqForm.selected_source_type}
                                  className="form-control"
                                  autoComplete="off"
                                  style={{
                                    borderRadius: '4px',
                                    height: "36px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    padding: "0 10px",
                                  }}
                                  onChange={(e) => {
                                    const value = e.target.value
                                    handleInputChange(e)
                                  }}
                                />
                              </div>
                            )}
                            {/* <div className="col-xl-2 mt-20p">
                              <label>Distance(KM)</label>
                              <input
                                type="text"
                                name="total_km"
                                disabled
                                value={rfqForm.total_km || ""}
                                className="form-control"
                                style={{
                                  borderRadius:'4px',
                                  height: "36px",
                                  border: "1px solid #ccc",
                                  borderRadius: "4px",
                                  padding: "0 10px",
                                }}
                                autoComplete="off"
                                onChange={(e) => {
                                  const value = e.target.value
                                  if (/^\s*(\d+(\.\d*)?)?\s*$/.test(value)) {
                                    handleInputChange(e)
                                  }
                                }}
                              />
                            </div> */}
                            <div className="col-xl-2 mt-20p">
                              <label>
                                Unit<span style={{ color: "red" }}>*</span>
                              </label>
                              <Select
                                value={units_list.filter((e) => e.value == rfqForm.units)}
                                closeMenuOnSelect={true}
                                onChange={(selectedOption) => handleSelectChange("units", selectedOption)}
                                options={units_list}
                                styles={{ control: (provided) => ({ ...provided, minHeight: "36px" }) }}
                                required
                              />
                            </div>
                            {rfqForm.units == "others" && (
                              <div className="col-xl-2 mt-20p">
                                <label>
                                  Enter Unit<span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                  type="text"
                                  name="selected_units"
                                  value={rfqForm.selected_units}
                                  autoComplete="off"
                                  className="form-control"
                                  style={{
                                    borderRadius: '4px',
                                    height: "36px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    padding: "0 10px",
                                  }}
                                  onChange={(e) => {
                                    const value = e.target.value
                                    handleInputChange(e)
                                  }}
                                  required
                                />
                              </div>
                            )}
                            <div className="col-xl-2 mt-20p">
                              <label>
                                Truck Type<span style={{ color: "red" }}>*</span>
                              </label>
                              <Select
                                value={truck_type.filter((e) => e.value === rfqForm.type_of_truck)}
                                closeMenuOnSelect={true}
                                onChange={(selectedOption) => handleSelectChange("type_of_truck", selectedOption)}
                                options={truck_type}
                                styles={{ control: (provided) => ({ ...provided, minHeight: "36px" }) }}
                                required
                              />
                            </div>
                            {rfqForm.type_of_truck == "others" && (
                              <div className="col-xl-2 mt-20p">
                                <label>
                                  Enter Truck Type<span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                  type="text"
                                  name="selected_truck_type"
                                  value={rfqForm.selected_truck_type}
                                  className="form-control"
                                  autoComplete="off"
                                  style={{
                                    borderRadius: '4px',
                                    height: "36px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    padding: "0 10px",
                                  }}
                                  onChange={(e) => {
                                    const value = e.target.value
                                    handleInputChange(e)
                                  }}
                                  required
                                />
                              </div>
                            )}
                            <div className="col-xl-2 mt-20p">
                              <label>
                                Bid Start Date<span style={{ color: "red" }}>*</span>
                              </label>
                              <Datetime
                                disableCloseOnClickOutside={false}
                                closeOnSelect={true}
                                value={rfqForm.bid_start_date}
                                isValidDate={current => {
                                  return current.isSameOrAfter(moment(new Date()), 'day');
                                }}
                                inputProps={{
                                  style: {
                                    height: '36px',
                                    backgroundColor: '#f7f7f7', // Light gray background
                                    // color: '#b0b0b0',           // Gray text color
                                    cursor: 'not-allowed',       // Show disabled cursor
                                    borderRadius: '4px'
                                  },
                                  disabled: true // Disable input to make it non-editable
                                }}
                                timeFormat="HH:mm"
                                dateFormat="YYYY-MM-DD"
                                onChange={(date) => handlerStartDateTime("bid_start_date", date)}
                                required
                              />
                            </div>
                            <div className="col-xl-2 mt-20p">
                              <label>
                                Indent Validity<span style={{ color: "red" }}>*</span>
                              </label>
                              <Select
                                value={bidvalidityoptions.filter((e) => e.value == rfqForm.quotation_validity_hours)}
                                closeMenuOnSelect={true}
                                onChange={(selectedOption) =>
                                  handleSelectChange("quotation_validity_hours", selectedOption)
                                }
                                options={bidvalidityoptions}
                                styles={{ control: (provided) => ({ ...provided, minHeight: "36px" }) }}
                                required
                              />
                            </div>
                            <div className="col-xl-2 mt-20p">
                              <label>
                                Bidding Cutoff (Minutes)<span style={{ color: "red" }}>*</span>
                              </label>
                              <Select
                                value={[
                                  { value: "00:15", label: "15 Minutes" },
                                  { value: "00:30", label: "30 Minutes" },
                                  { value: "00:45", label: "45 Minutes" },
                                  { value: "01:00", label: "60 Minutes" },
                                  { value: "01:15", label: "75 Minutes" },
                                  { value: "01:30", label: "90 Minutes" },
                                ].find((e) => e.value === rfqForm.bidding_window)} // controlled value
                                closeMenuOnSelect={true}
                                onChange={(selectedOption) => {
                                  if (!selectedOption) return;

                                  const minutes = selectedOption.value;

                                  // // Convert to HH:mm (backend expects this format)
                                  // const hours = String(Math.floor(minutes / 60)).padStart(2, "0");
                                  // const mins = String(minutes % 60).padStart(2, "0");
                                  // const formattedValue = `${hours}:${mins}`;

                                  // // Validation check
                                  // const validityMinutes =
                                  //   (Number(rfqForm.quotation_validity_hours) || 0) * 60;

                                  // if (minutes > validityMinutes) {
                                  //   setSweetAlert({
                                  //     show: true,
                                  //     basicTitle: "Bidding cutoff should be less than Indent validity",
                                  //     basicType: "error",
                                  //   });
                                  //   return;
                                  // }

                                  // Save HH:mm to DB
                                  handleInputChange({
                                    target: { name: "bidding_window", value: minutes },
                                  });

                                  // Save raw minutes for UI
                                  setRfqForm((prev) => ({
                                    ...prev,
                                    // bidding_window_minutes: minutes, // for UI
                                    bidding_window: minutes, // for DB
                                  }));
                                }}
                                options={[
                                  { value: "00:10", label: "10 Minutes" },
                                  { value: "00:15", label: "15 Minutes" },
                                  { value: "00:20", label: "20 Minutes" },
                                  // { value: "00:25", label: "25 Minutes" },
                                  { value: "00:30", label: "30 Minutes" },
                                ]}
                                styles={{ control: (provided) => ({ ...provided, minHeight: "36px" }) }}
                                required
                              />
                            </div>

                            <div className="col-xl-2 mt-20p">
                              <label>
                                Negotiation Cutoff (Minutes)<span style={{ color: "red" }}>*</span>
                              </label>
                              <Select
                                value={[
                                  { value: "00:10", label: "10 Minutes" },
                                  { value: "00:15", label: "15 Minutes" },
                                  { value: "00:20", label: "20 Minutes" },
                                  { value: "00:25", label: "25 Minutes" },
                                  { value: "00:30", label: "30 Minutes" },
                                ].find((e) => e.value === rfqForm.negotiation_window)} // UI control
                                closeMenuOnSelect={true}
                                onChange={(selectedOption) => {
                                  if (!selectedOption) return;

                                  const minutes = selectedOption.value;


                                  setRfqForm((prev) => ({
                                    ...prev,
                                    // negotiation_window_minutes: minutes, // for UI
                                    negotiation_window: minutes, // for DB
                                  }));

                                  // If your handleInputChange updates the DB value
                                  handleInputChange({
                                    target: { name: "negotiation_window", value: minutes },
                                  });
                                }}
                                options={[
                                  { value: "00:10", label: "10 Minutes" },
                                  { value: "00:15", label: "15 Minutes" },
                                  { value: "00:20", label: "20 Minutes" },
                                  { value: "00:25", label: "25 Minutes" },
                                  { value: "00:30", label: "30 Minutes" },
                                ]}
                                styles={{ control: (provided) => ({ ...provided, minHeight: "36px" }) }}
                                required
                              />
                            </div>


                            <div className="col-xl-2 mt-20p">
                              <label>
                                Pickup Date<span style={{ color: "red" }}>*</span>
                              </label>
                              <Datetime
                                disableCloseOnClickOutside={false}
                                closeOnSelect={true}
                                isValidDate={(current) => current.isSameOrAfter(moment(new Date()), 'day')}
                                inputProps={{
                                  style: {
                                    height: '36px',
                                    borderRadius: '4px'
                                  }
                                }}
                                value={rfqForm.pickup_date}
                                timeFormat={false}  // Disables time selection
                                dateFormat="YYYY-MM-DD"
                                onChange={(date) => handlerPickupDateTime("pickup_date", date)}
                                required
                              />
                            </div>
                            <div className="col-xl-2 mt-20p">
                              <label>Base Price (₹)</label>
                              <input
                                type="text" // Keep it as text
                                name="base_price"
                                value={rfqForm.base_price}
                                className="form-control"
                                style={{
                                  borderRadius: '4px',
                                  height: '36px'
                                }}
                                autoComplete="off"
                                onChange={(e) => {
                                  const value = e.target.value;

                                  // Allow only whole numbers, but not leading 0
                                  if (/^\d*$/.test(value)) {
                                    if (value === "0") {
                                      // Prevent "0" as the only value
                                      return;
                                    }
                                    handleInputChange(e); // Call your change handler if valid
                                  }
                                }}
                              />

                            </div>
                            <div className="col-xl-4 mt-17p">
                              <label>Payment Terms</label>
                              <input
                                type="text"
                                id="payment_terms"
                                name="payment_terms"
                                value={rfqForm.payment_terms}
                                className="form-control"
                                style={{
                                  borderRadius: '4px',
                                  height: '36px', // Height of the input
                                  // paddingRight: '90px', // Leave space for the button inside the input
                                  backgroundColor: '#f7f7f7', // Optional background color
                                }}
                                autoComplete="off"
                                onChange={handleInputChange}
                                readOnly
                              />
                            </div>

                            <div className="col-xl-12 mb-10p">
                              <label>Vendors<span style={{ color: "red" }}>*</span></label>
                              {/* <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "8px",
                                  border: "1px solid #ccc",
                                  borderRadius: "6px",
                                  padding: "6px",
                                  minHeight: "36px",
                                  backgroundColor: "#fff",
                                }}
                              >
                                {vendorslist.map((vendor, index) => (
                                  <span
                                    key={index}
                                    style={{
                                      backgroundColor: "#d1e7dd", 
                                      color: "#0f5132",         
                                      padding: "4px 10px",
                                      borderRadius: "6px",
                                      fontSize: "13px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {vendor.label}
                                  </span>
                                ))}

                                <input
                                  type="text"
                                  disabled
                                  style={{
                                    border: "none",
                                    outline: "none",
                                    flex: "1",
                                    minWidth: "60px",
                                    background: "transparent",
                                  }}
                                />
                              </div> */}

                              <Select
                                value={rfqForm.vendors_mail || []} // UI control
                                closeMenuOnSelect={true}
                                isMulti={true}
                                onChange={(selectedOption) => {
                                  if (!selectedOption) return;
                                  setRfqForm((prev) => {
                                    return { ...prev, vendors_mail: selectedOption }
                                  })
                                }}
                                options={vendorslist}
                                styles={{ control: (provided) => ({ ...provided, minHeight: "36px" }) }}
                                required
                              />


                            </div>


                          </div>
                        </div>
                        {/* Dealer & Material Info Section */}
                        <div
                          className="card"
                          style={{
                            border: "1px solid #e0e0e0",
                            borderRadius: "8px",
                            marginBottom: "20px",
                            marginTop: "20px",
                          }}
                        >
                          <div
                            style={{
                              // backgroundColor: "#e3f2fd",
                              padding: "16px 20px",
                              // borderBottom: "1px solid #e0e0e0",
                              fontSize: "16px",
                              fontWeight: "600",
                              // color: "#666",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <h5 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "20px" }}>Dealer & Material Information <span style={{ color: "red" }}>*</span></h5>
                            {/* <span>Dealer(s) & Material(s) Information</span> */}
                            <button
                              type="button"
                              className='btn'
                              onClick={openAddDealerModal}
                              style={{
                                backgroundColor: "#28a745",
                                color: "white",
                                border: "none",
                                padding: "8px 15px",
                                borderRadius: "5px",
                                cursor: "pointer",
                                fontSize: "14px",
                              }}
                            >
                              Add
                            </button>
                          </div>
                          <div style={{ padding: "20px", marginTop: '-32px' }}>
                            {dealers.length === 0 || dealers.every(dealer =>
                              !dealer.dealer_code &&
                              !dealer.dealer_name &&
                              !dealer.dealer_city &&
                              !dealer.dealer_state &&
                              !dealer.dealer_pincode &&
                              (!dealer.materials || dealer.materials.length === 0)
                            ) ? (
                              <>
                                <div style={{ overflowX: "auto" }}>
                                  <table className="dealer-table">
                                    <thead>
                                      <tr className="dealer-table-header">
                                        <th rowSpan="2">Dealer Code</th>
                                        <th rowSpan="2">Name</th>
                                        <th rowSpan="2">City</th>
                                        <th rowSpan="2">State</th>
                                        <th rowSpan="2">Pincode</th>
                                        <th rowSpan="2">Material</th>
                                        <th rowSpan="2">Prerequisite</th>
                                        <th rowSpan="2">Qty</th>
                                        <th colSpan="3" className="dealer-table-dimensions-header">Dimensions</th>
                                        <th rowSpan="2"></th>
                                      </tr>
                                      <tr className="dealer-table-header">
                                        <th>L</th>
                                        <th>B</th>
                                        <th>H</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td colSpan="12" className="no-items-text">
                                          Currently you don't have any items in the List.{" "}
                                          <a
                                            href="#"
                                            onClick={openAddDealerModal}
                                            className='add-dealer-link'
                                          >
                                            Add Dealer Information & Material
                                          </a>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>

                                </div>

                              </>

                            ) : (
                              <div style={{ overflowX: "auto" }}>
                                <table className="dealer-table">
                                  <thead>
                                    <tr className="dealer-table-header">
                                      <th rowSpan="2">Dealer Code</th>
                                      <th rowSpan="2">Name</th>
                                      <th rowSpan="2">City</th>
                                      <th rowSpan="2">State</th>
                                      <th rowSpan="2">Pincode</th>
                                      <th rowSpan="2">Material</th>
                                      <th rowSpan="2">Prerequisite</th>
                                      <th rowSpan="2">Qty</th>
                                      <th colSpan="3" className="dealer-table-dimensions-header">Dimensions</th>
                                      <th rowSpan="2"></th>
                                    </tr>
                                    <tr className="dealer-table-header">
                                      <th>L</th>
                                      <th>B</th>
                                      <th>H</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {dealers.map((dealer, dealerIndex) => {
                                      if (!isDealerRowFilled(dealer)) return null;

                                      return (dealer.materials || []).map((material, materialIndex) => (
                                        <tr key={`${dealerIndex}-${materialIndex}`}>
                                          {materialIndex === 0 && (
                                            <>
                                              <td rowSpan={dealer.materials.length} className="dealer-table-cell">{dealer.dealer_code}</td>
                                              <td rowSpan={dealer.materials.length} className="dealer-table-cell">
                                                {dealer.dealer_name && dealer.dealer_name.length > 10 ? (
                                                  <div className="text-with-tooltip">
                                                    {toTitleCase(dealer.dealer_name).substring(0, 10)}...
                                                    <div className="eye-icon-wrapper">
                                                      <img
                                                        src={require("../../assets/images/eye (1).svg")}
                                                        style={{
                                                          cursor: "pointer",
                                                          height: "11px",
                                                        }}
                                                        alt="Dealer Name"
                                                      />
                                                      <span className="tooltip-text1">
                                                        {toTitleCase(dealer.dealer_name)}
                                                      </span>
                                                    </div>
                                                  </div>
                                                ) : (
                                                  toTitleCase(dealer.dealer_name) || "NA"
                                                )}
                                              </td>
                                              <td rowSpan={dealer.materials.length} className="dealer-table-cell">{toTitleCase(dealer.dealer_city)}</td>
                                              <td rowSpan={dealer.materials.length} className="dealer-table-cell">{dealer.dealer_state}</td>
                                              <td rowSpan={dealer.materials.length} className="dealer-table-cell">{dealer.dealer_pincode}</td>
                                            </>
                                          )}

                                          <td className="dealer-table-cell">
                                            {material.material_type === "others" ? material.other_material_type : material.material_type}
                                          </td>
                                          <td className="dealer-table-cell">
                                            {material.basic_requirment && material.basic_requirment.length > 25 ? (
                                              <div className="text-with-tooltip">
                                                {material.basic_requirment.substring(0, 25)}...
                                                <div className="eye-icon-wrapper">
                                                  <img
                                                    src={require("../../assets/images/eye (1).svg")}
                                                    style={{
                                                      cursor: "pointer",
                                                      // position: "relative",
                                                      height: "11px",
                                                    }}
                                                    alt="RFQ"
                                                  />        <span className="tooltip-text">
                                                    {material.basic_requirment}
                                                  </span>
                                                </div>
                                              </div>
                                            ) : (
                                              material.basic_requirment || "NA"
                                            )}
                                          </td>
                                          <td className="dealer-table-cell">{material.quantity}</td>
                                          <td className="dealer-table-cell">{material.material_length} {material.material_units}</td>
                                          <td className="dealer-table-cell">{material.material_breath} {material.material_units}</td>
                                          <td className="dealer-table-cell">{material.material_height} {material.material_units}</td>
                                          <td className="dealer-table-cell dealer-table-actions">
                                            <div className="action-buttons-wrapper">
                                              <button type="button" onClick={() => editMaterial(dealer)} className="btn dealer-table-editbtn">
                                                <img src={require('../../assets/icons/editpencil.svg')} alt="Edit" />
                                              </button>
                                              <button type="button" onClick={() => removeMaterial(dealerIndex, materialIndex)} className="btn dealer-table-deletebtn">
                                                <img src={require('../../assets/icons/delete.svg')} style={{ height: '15px' }} alt="Delete" />
                                              </button>
                                            </div>
                                          </td>

                                        </tr>
                                      ));
                                    })}
                                  </tbody>
                                </table>
                                <div className="distance-info-box">
                                  Distance From Source&nbsp;<span className="bold-text"> ({rfqForm.source})</span> To Destination(S) <span className="distance-value">{rfqForm.total_km} Km</span>
                                </div>

                              </div>
                            )}
                          </div>
                        </div>

                        {/* Additional Information Section */}
                        {/* <div
                            className="card"
                            style={{
                              border: "1px solid #e0e0e0",
                              borderRadius: "8px",
                              marginBottom: "20px",
                              marginTop: "20px",
                            }}
                          >
                            <div
                              style={{
                                backgroundColor: "#e3f2fd",
                                padding: "16px 20px",
                                borderBottom: "1px solid #e0e0e0",
                                fontSize: "16px",
                                fontWeight: "600",
                                color: "#666",
                              }}
                            >
                              Additional Information
                            </div>
                            <div style={{ padding: "20px", display: "flex", flexDirection: "column", gap: "20px" }}>
                              <div>
                                <label style={{ display: "block", marginBottom: "5px" }}>Comments</label>
                                <textarea
                                  name="additional_comments"
                                  value={rfqForm.additional_comments}
                                  onChange={handleInputChange}
                                  style={{
                                    width: "100%",
                                    minHeight: "100px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    padding: "10px",
                                    resize: "vertical",
                                  }}
                                ></textarea>
                              </div>
                              <div>
                                <label style={{ display: "block", marginBottom: "5px" }}>Upload file</label>
                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                  <input
                                    type="text"
                                    readOnly
                                    value={rfqForm.uploadFile ? rfqForm.uploadFile.name : ""}
                                    style={{
                                      flexGrow: 1,
                                      height: "45px",
                                      border: "1px solid #ccc",
                                      borderRadius: "4px",
                                      padding: "0 10px",
                                      backgroundColor: "#f0f0f0",
                                    }}
                                  />
                                  <input
                                    type="file"
                                    id="fileInput"
                                    style={{ display: "none" }}
                                    onChange={onchangeFileHandler}
                                    accept=".pdf,.png,.jpeg,.jpg"
                                  />
                                  <button
                                    type="button"
                                    onClick={handleDivClick}
                                    style={{
                                      backgroundColor: "#28a745",
                                      color: "white",
                                      border: "none",
                                      padding: "10px 15px",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    Select File
                                  </button>
                                </div>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  width: "100%",
                                }}
                              >
                                <label style={{ marginBottom: "0" }}>Is Material is over Breadth</label>
                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                  <input
                                    type="radio"
                                    id="overBreathYes"
                                    name="over_breath"
                                    checked={rfqForm.over_breath === true}
                                    onChange={() => handleCheckboxChange("over_breath", true)}
                                    style={{ transform: "scale(1.2)", marginRight: "4px" }}
                                  />
                                  <label htmlFor="overBreathYes" style={{ marginBottom: "0" }}>
                                    Yes
                                  </label>
                                  <input
                                    type="radio"
                                    id="overBreathNo"
                                    name="over_breath"
                                    checked={rfqForm.over_breath === false}
                                    onChange={() => handleCheckboxChange("over_breath", false)}
                                    style={{ transform: "scale(1.2)", marginRight: "4px" }}
                                  />
                                  <label htmlFor="overBreathNo" style={{ marginBottom: "0" }}>
                                    No
                                  </label>
                                </div>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  width: "100%",
                                }}
                              >
                                <label style={{ marginBottom: "0" }}>Is Material is over Length</label>
                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                  <input
                                    type="radio"
                                    id="overLengthYes"
                                    name="over_length"
                                    checked={rfqForm.over_length === true}
                                    onChange={() => handleCheckboxChange("over_length", true)}
                                    style={{ transform: "scale(1.2)", marginRight: "4px" }}
                                  />
                                  <label htmlFor="overLengthYes" style={{ marginBottom: "0" }}>
                                    Yes
                                  </label>
                                  <input
                                    type="radio"
                                    id="overLengthNo"
                                    name="over_length"
                                    checked={rfqForm.over_length === false}
                                    onChange={() => handleCheckboxChange("over_length", false)}
                                    style={{ transform: "scale(1.2)", marginRight: "4px" }}
                                  />
                                  <label htmlFor="overLengthNo" style={{ marginBottom: "0" }}>
                                    No
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div> */}
                        <div
                          className="card"
                          style={{
                            border: "1px solid #e0e0e0",
                            borderRadius: "8px",
                            marginBottom: "20px",
                            marginTop: "20px",
                          }}
                        >
                          <div className="customcard-header">
                            <h5 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "20px" }}>Additional Information</h5>
                          </div>

                          {/* 🔹 Content Section */}
                          <div style={{ padding: "20px", display: "flex", flexDirection: "column", marginTop: '-60px' }}>
                            {/* Comments */}
                            <div>
                              <label style={{ display: "block", marginBottom: "5px" }}>Comments</label>
                              <textarea
                                name="additional_comments"
                                value={rfqForm.additional_comments}
                                onChange={handleInputChange}
                                style={{
                                  width: "100%",
                                  //   minHeight: "100px",
                                  border: "1px solid #ccc",
                                  borderRadius: "4px",
                                  padding: "10px",
                                  resize: "vertical",
                                }}
                              />
                            </div>

                            {/* Upload File */}
                            <div>
                              <label style={{ display: "block", marginBottom: "5px" }}>Upload file</label>

                              <label htmlFor="fileInput" className="fileuploadbox-container">
                                <div className="fileuploadbox-filename">
                                  {rfqForm.uploadFile ? rfqForm.uploadFile.name : "No file chosen"}
                                </div>
                                <div className="fileuploadbox-selectbtn">
                                  Select File
                                </div>
                              </label>


                              <input
                                type="file"
                                id="fileInput"
                                onChange={onchangeFileHandler}
                                accept=".pdf,.png,.jpeg,.jpg,.xls,.xlsx"
                                style={{ display: "none" }}
                              />
                              {rfqForm.upload_for_road && (
                                <div style={{ marginTop: '8px' }}>
                                  Uploaded File: <strong>{rfqForm.upload_for_road || rfqForm.upload_for_road}</strong>
                                </div>
                              )}

                            </div>


                            {/* Over Breadth */}
                            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                              <label style={{ minWidth: "200px", marginBottom: "0" }}>Is Material over Breadth ?</label>
                              <input
                                type="radio"
                                id="overBreathYes"
                                style={{ marginTop: '11px' }}
                                name="over_breath"
                                checked={rfqForm.over_breath === true}
                                onChange={() => handleCheckboxChange("over_breath", true)}
                              />
                              <label htmlFor="overBreathYes">Yes</label>
                              <input
                                type="radio"
                                style={{ marginTop: '11px' }}
                                id="overBreathNo"
                                name="over_breath"
                                checked={rfqForm.over_breath === false}
                                onChange={() => handleCheckboxChange("over_breath", false)}
                              />
                              <label htmlFor="overBreathNo">No</label>
                            </div>

                            {/* Over Length */}
                            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                              <label style={{ minWidth: "200px", marginBottom: "0" }}>Is Material over Length ?</label>
                              <input
                                type="radio"
                                id="overLengthYes"
                                name="over_length"
                                style={{ marginTop: '11px' }}
                                checked={rfqForm.over_length === true}
                                onChange={() => handleCheckboxChange("over_length", true)}
                              />
                              <label htmlFor="overLengthYes">Yes</label>
                              <input
                                type="radio"
                                id="overLengthNo"
                                style={{ marginTop: '11px' }}
                                name="over_length"
                                checked={rfqForm.over_length === false}
                                onChange={() => handleCheckboxChange("over_length", false)}
                              />
                              <label htmlFor="overLengthNo">No</label>
                            </div>
                          </div>
                        </div>

                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <div className="dealer-header-actions">




                  <button
                    type="button"
                    onClick={() => {
                      window.location.href = "/indentsummary";
                    }}
                    className="btn dealerbtn-cancel"
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    onClick={onSaveDraft}
                    className="btn draftsavebtn"
                  >
                    Save as Draft
                  </button>

                  <button
                    type="button"
                    onClick={handlePreview}
                    className="btn previewsubmitbtn"
                  >
                    Preview & Submit
                  </button>

                </div>

              </form>
              {/* Add Dealer Modal */}
              {isAddDealerModalOpen && (
                <div

                >
                  <div
                    className={"slide-r " + (isAddDealerModalOpen ? "slider-translate-75p" : "")}
                    style={{
                      // width: "75%",
                      // maxWidth: "960px",
                      height: "100vh",
                      background: "#fff",
                      padding: "25px",
                      borderRadius: "8px 0 0 8px",
                      overflowY: "auto",
                      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                      transform: isAddDealerModalOpen ? "translateX(0)" : "translateX(100%)",
                      transition: "transform 0.3s ease-out",
                    }}
                  >
                    {/* Header */}
                    <div className="dealersectionheader">
                      {isEditing ? 'Edit Dealer Information & Material' : 'Add Dealer Information & Material'}
                      <button onClick={closeAddDealerModal} className="btn dealersectionheader-closebtn">
                        &times;
                      </button>
                    </div>


                    {/* Dealer Details Section */}
                    <div style={{ marginBottom: "30px" }}>
                      <div className="dealersectiontitle">
                        Dealer Details
                      </div>


                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1.2fr 1.5fr 1fr 1fr 1fr",
                          gap: "15px",
                        }}
                      >
                        <div>
                          <label>Dealer Code<span style={{ color: "red" }}>*</span></label>
                          <Select
                            value={citiesoption.filter((e) => e.label === newDealerData.dealer_code)}
                            onChange={select_new_dealer_code}
                            options={getNewDealerCodesOptions(citiesoption, dealers)}
                            styles={{ control: (base) => ({ ...base, minHeight: "36px" }) }}
                          />
                        </div>
                        {["dealer_name", "dealer_city", "dealer_state", "dealer_pincode"].map((field, idx) => (
                          <div key={idx}>
                            <label>{field.replace("dealer_", "").replace("_", " ").replace(/\b\w/g, c => c.toUpperCase())}</label>
                            <input
                              type="text"
                              value={toTitleCase(newDealerData[field])}
                              readOnly
                              className="readonlyinput"
                            />

                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Add Material Section */}
                    <div style={{ marginBottom: "30px" }}>
                      {/* Material Section Wrapper */}
                      <div
                        style={{
                          border: "1px dashed #90caf9",
                          borderRadius: "6px",
                          background: "#f8fdff", // ✅ light background like in screenshot
                          padding: "12px",
                        }}
                      >
                        {/* Header Row */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "10px",
                          }}
                        >
                          <span style={{ fontWeight: "500", fontSize: "14px", color: "#333" }}>
                            Add Material(s)
                            <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                          </span>
                          <button
                            type="button"
                            className='btn'
                            onClick={addNewMaterialToModal}
                            style={{
                              background: "#4cd4b0", // ✅ green button like in screenshot
                              color: "#fff",
                              border: "none",
                              borderRadius: "4px",
                              padding: "4px 12px",
                              cursor: "pointer",
                              fontSize: "13px",
                            }}
                          >
                            Add
                          </button>
                        </div>

                        {/* Table */}
                        <table
                          style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            fontSize: "13px",
                            background: "#fff",
                          }}
                        >
                          <thead>
                            <tr style={{ background: "#01579b", color: "white", height: "40px" }}>
                              <th style={{ padding: "8px", textAlign: "left", border: "0.5px solid #FFFFFF", width: "14%" }}>Material <span style={{ color: "red" }}>*</span></th>
                              <th colSpan="4" style={{ padding: "8px", border: "0.5px solid #FFFFFF", width: "5%" }}>
                                Dimensions
                              </th>
                              <th style={{ padding: "8px", textAlign: "left", border: "0.5px solid #FFFFFF", width: "5%" }}>Qty <span style={{ color: "red" }}>*</span></th>
                              <th style={{ padding: "8px", textAlign: "left", border: "0.5px solid #FFFFFF", width: "18%" }}>Prerequisite</th>
                              <th style={{ padding: "8px", textAlign: "center", width: "5%" }}></th> {/* Action Column */}

                            </tr>
                          </thead>
                          <tbody>
                            {Array.isArray(newDealerData.materials) &&
                              newDealerData.materials.map((material, index) => (
                                <tr key={index} style={{ borderBottom: "1px solid #e0e0e0", height: "40px" }}>
                                  {/* Material */}
                                  <td className="material-cell" style={{ border: "1px solid rgb(224, 224, 224)", width: "14%" }}>
                                    <Select
                                      value={material_list.find((e) => e.value === material.material_type) || null} // <- fallback to null
                                      // value={material_list.find((e) => e.value === material.material_type)}
                                      onChange={(opt) => handleNewMaterialChange(index, "material_type", opt.value)}
                                      options={material_list}
                                      styles={{
                                        control: (base) => ({
                                          ...base,
                                          minHeight: "34px",
                                          height: "34px", // Explicitly set height
                                          fontSize: "13px",
                                          borderColor: "#ccc",
                                          boxShadow: "none", // Remove default shadow
                                          "&:hover": {
                                            borderColor: "#ccc", // Keep border color consistent on hover
                                          },
                                        }),
                                        dropdownIndicator: (base) => ({ ...base, padding: 4 }),
                                        indicatorsContainer: (base) => ({ ...base, height: "34px" }),
                                        valueContainer: (base) => ({
                                          ...base,
                                          padding: "0 8px", // Adjust padding inside the control
                                        }),
                                        singleValue: (base) => ({
                                          ...base,
                                          color: "#333", // Ensure text color is consistent
                                        }),
                                      }}
                                    />
                                    {material.material_type == "others" && <input
                                      type="text"
                                      value={material.other_material_type || ''}
                                      onChange={(e) => {
                                        let val = e.target.value;
                                        if (val == "" || val[0] != " ") {
                                          console.log(val, "value")
                                          handleNewMaterialChange(index, "other_material_type", capitalizeEachWord(val))
                                        }
                                        else {
                                          handleNewMaterialChange(index, "other_material_type", val ? capitalizeEachWord(val).trim() : "")
                                        }
                                      }
                                      }

                                      className="material-input mt-1"
                                      style={{
                                        width: "100%",
                                        height: "34px",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                        padding: "0 8px",
                                        fontSize: "13px",
                                      }}
                                    />}
                                  </td>
                                  {/* Dimensions: W, L, H */}
                                  {["material_length", "material_breath", "material_height"].map((dim, idx) => {
                                    const placeholders = { material_length: 'L', material_breath: 'B', material_height: 'H' };
                                    return (
                                      <td
                                        key={idx}
                                        className="dim-cell"
                                        style={{ border: "1px solid rgb(224, 224, 224)", width: "5%" }}
                                      >
                                        <input
                                          type="text"
                                          value={material[dim] || ''}
                                          placeholder={placeholders[dim]}
                                          onChange={(e) => {
                                            let val = e.target.value;

                                            // Allow empty input (clearing field)
                                            if (val === '') {
                                              handleNewMaterialChange(index, dim, '');
                                              return;
                                            }

                                            // Block invalid characters
                                            if (!/^\d*\.?\d*$/.test(val)) {
                                              return;
                                            }

                                            // If starts with '0' and length > 1, next char must be '.'
                                            if (val.startsWith('0') && val.length > 1 && val[1] !== '.') {
                                              return;
                                            }

                                            // Prevent more than 5 digits (excluding decimal)
                                            if (val.replace('.', '').length > 5) {
                                              return;
                                            }

                                            // Allow partial '0' or '0.'
                                            if (val === '0' || val === '0.') {
                                              handleNewMaterialChange(index, dim, val);
                                              return;
                                            }

                                            // Parse float and allow >= 0
                                            const floatVal = parseFloat(val);
                                            if (!isNaN(floatVal) && floatVal >= 0) {
                                              handleNewMaterialChange(index, dim, val);
                                            }
                                          }}
                                          onKeyDown={(e) => {
                                            if (["e", "E", "+", "-"].includes(e.key)) {
                                              e.preventDefault();
                                            }
                                          }}
                                          onPaste={(e) => {
                                            const pasted = e.clipboardData.getData("text");
                                            if (
                                              !/^\d*\.?\d*$/.test(pasted) ||
                                              pasted.replace('.', '').length > 5 ||
                                              parseFloat(pasted) < 0 ||
                                              (pasted.startsWith('0') && pasted.length > 1 && pasted[1] !== '.')
                                            ) {
                                              e.preventDefault();
                                            }
                                          }}
                                          className="material-input"
                                          style={{
                                            width: "100%",
                                            height: "34px",
                                            border: "1px solid #ccc",
                                            borderRadius: "4px",
                                            padding: "0 8px",
                                            fontSize: "13px",
                                          }}
                                        />
                                      </td>
                                    );
                                  })}






                                  {/* Unit */}
                                  <td className="unit-cell" style={{ border: "1px solid rgb(224, 224, 224)" }}>
                                    <Select
                                      isSearchable={false}
                                      value={{ label: material.material_units, value: material.material_units }}
                                      onChange={(opt) => handleNewMaterialChange(index, "material_units", opt.value)}
                                      options={materialdimensionlist}
                                      styles={{
                                        control: (base) => ({
                                          ...base,
                                          minHeight: "34px",
                                          height: "34px", // Explicitly set height
                                          fontSize: "13px",
                                          borderColor: "#ccc",
                                          boxShadow: "none", // Remove default shadow
                                          "&:hover": {
                                            borderColor: "#ccc", // Keep border color consistent on hover
                                          },
                                        }),
                                        dropdownIndicator: (base) => ({ ...base, padding: 4 }),
                                        indicatorsContainer: (base) => ({ ...base, height: "34px" }),
                                        valueContainer: (base) => ({
                                          ...base,
                                          padding: "0 8px", // Adjust padding inside the control
                                        }),
                                        singleValue: (base) => ({
                                          ...base,
                                          color: "#333", // Ensure text color is consistent
                                        }),
                                      }}
                                    />
                                  </td>
                                  {/* Qty */}
                                  <td className="qty-cell materialcell-border" style={{ width: '5%' }}>
                                    <input
                                      type="text"
                                      placeholder="Qty"
                                      value={material.quantity === 0 ? '' : material.quantity}
                                      onChange={(e) => {
                                        let value = e.target.value;

                                        // Allow clearing field
                                        if (value === '') {
                                          handleNewMaterialChange(index, "quantity", '');
                                          return;
                                        }

                                        // Allow only digits (no decimals allowed)
                                        if (!/^\d+$/.test(value)) {
                                          return;
                                        }

                                        // Prevent leading zeros like '00', '000'
                                        if (value.length > 1 && value.startsWith('0')) {
                                          return;
                                        }

                                        // Prevent more than 5 digits
                                        if (value.length > 5) {
                                          return;
                                        }

                                        // Ensure number > 0
                                        const intVal = parseInt(value, 10);
                                        if (intVal > 0) {
                                          handleNewMaterialChange(index, "quantity", value);
                                        }
                                      }}
                                      onKeyDown={(e) => {
                                        if (["e", "E", "+", "-", ".", ","].includes(e.key)) {
                                          e.preventDefault();
                                        }
                                      }}
                                      onPaste={(e) => {
                                        const pasted = e.clipboardData.getData("text");
                                        if (
                                          !/^\d+$/.test(pasted) || // Only digits
                                          pasted.length > 5 ||
                                          parseInt(pasted, 10) <= 0 ||
                                          (pasted.length > 1 && pasted.startsWith('0')) // No leading zeros
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                      className="materialcell-input"
                                    />
                                  </td>

                                  {/* Prerequisite Cell */}
                                  <td className="requirement-cell materialcell-border" style={{ width: "18%" }}>
                                    <input
                                      type="text"
                                      value={material.basic_requirment}
                                      onChange={(e) => handleNewMaterialChange(index, "basic_requirment", e.target.value)}
                                      className="materialcell-input"
                                      style={{ width: "100%" }}
                                    />
                                  </td>

                                  {/* Action (Delete) Cell */}
                                  <td className="action-cell" style={{ borderRight: "1px solid rgb(224, 224, 224)", textAlign: "center", width: "5%" }}>
                                    <button
                                      type="button"
                                      onClick={() => removeMaterialFromModal(index)}
                                      className="btn removematerialbtn"
                                    >
                                      <img src={require('../../assets/icons/delete.svg')} style={{ height: '15px' }} />
                                    </button>
                                  </td>

                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>




                    {/* Footer Buttons */}
                    <div className="dealerbtn-container">
                      <button onClick={closeAddDealerModal} className="btn dealerbtn-cancel">
                        Cancel
                      </button>
                      {isEditing ? '' :
                        <button onClick={saveandaddNewDealer} className="btn dealerbtn-saveadd">
                          Save & Add New
                        </button>}

                      <button onClick={saveNewDealer} className="btn dealerbtn-save">
                        {isEditing ? 'Update' : 'Save'}
                      </button>
                    </div>

                  </div>
                </div>
              )}



            </>
          </div>
        </div>
      </>
      <Modal open={isPreviewMode} onClose={() => setIsPreviewMode(false)}>
        <RFQView rfqForm={rfqForm}
          dealers={dealers}
          unitsOptions1={units_list}
          checkforcreateindent={true}
          onBackToEdit={() => setIsPreviewMode(false)}
          onSubmitRfq={onClickcreaterfq} />
      </Modal>
      <Toast
        message={toast.message}
        type={toast.type}
        title={toast.title}
        onClose={() => setToast({ message: "", type: "" })}
      />

      <div className={"dataLoadpage " + (loadshow)}>
      </div>
      <div className={"dataLoadpageimg " + (loadshow)}>
        <div class="loader-box"><div class="loader-box"><div class="rotate dashed colored"></div></div></div>
      </div>
      <div className={"overlay " + (overlay)} onClick={onClickHideall}></div>
    </div>
  )
}

export default CreateRFQComponent

function toTitleCase(sentence) {
  return sentence
    .toLowerCase() // make everything lowercase first
    .split(' ')    // split into words
    .filter(word => word.trim() !== '') // remove extra spaces
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

function capitalizeEachWord(value) {
  if (!value) return ''; // Handle empty strings
  return value
    .split(' ') // Split the string into words by spaces
    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
    .join(' '); // Join the words back with spaces
}
